import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, NgZone, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { HttpClientHelper } from '../../../appServices/apiClient';
import { MentoringEvents } from '../../../helpers/events';
import { UtilityHelper } from '../../../helpers/utilityHelper';
import { MentoringSocketService } from '../../../messageServices/mentoringSocketService';
import { MentoringServices } from '../../../appServices/mentoring';
import { AbstractBaseComponent } from '../../../app.baseComponent';
import { MessagingHelper } from '../../../helpers/messagingHelper';
import { ToastsManager } from '../../../helpers/toastsManager';
import { VideoChatService } from '../../../../app/messageServices/video-chat-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import ZoomVideo, { MobileVideoFacingMode } from '@zoom/videosdk'
import moment from 'moment';
import { Router } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { AngularDraggableModule } from 'angular2-draggable';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {  MAT_DIALOG_DATA ,MatDialog,MatDialogModule,MatDialogRef } from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { LeaveConfirmPopupComponent } from 'app/shared/leave-confirm-popup/leave-confirm-popup.component';

import { BaThemeSpinner } from 'app/theme/services';
import Bugsnag from '@bugsnag/js';

interface ZoomParticipant {
    audio: string;
    bVideoOn: boolean;
    displayName: string;
    isAllowIndividualRecording: boolean;
    isHost: boolean;
    isManager: boolean;
    isPhoneUser: boolean;
    isVideoConnect: boolean;
    muted: boolean;
    subsessionId: string;
    userGuid: string;
    userId: number;
  }
  
@Component({
    selector: 'app-video-calls',
    templateUrl: './video-calls.component.html',
    styleUrls: ['./video-calls.component.scss'],
    imports: [NgClass, AngularDraggableModule, CommonModule, FormsModule, TranslateModule, MatButtonModule, MatIconModule, MatMenuModule, MatFormFieldModule, MatSelectModule, MatTooltipModule, MatRippleModule, MatDialogModule, MatProgressSpinnerModule]
})
export class VideoCallsComponent extends AbstractBaseComponent implements OnInit {
    @ViewChild('localVideo', { static: true }) localVideoElementRef: ElementRef<HTMLVideoElement>;
    @ViewChild('remoteVideo', { static: true }) remoteVideoElementRef: ElementRef<HTMLVideoElement>;
    @Input() dataResponse: any;
    // @Output() closeVideo = new EventEmitter<void>();
    isVideoLive:boolean
    isMissedCall: boolean = true;
    isMuted: boolean = true;
    isMutedParticipant: boolean = true;
    isVideoDisabled = false;
    inBounds = true;
    edge = {
        top: true,
        bottom: true,
        left: true,
        right: true
    };
    channelList: any = [];
    channelUserList: any = [];
    channelId: any = '';
    activeGroupChannelUsers: any;
    emptyChannelTitle: any = '';
    emptyChannelInformation: any;
    channelType: any = '';
    isPhoneJoined: boolean = false
    showVideModalPopUp : any = $('#showVideModalPopUp')
    private remoteVideoElement: any;
    private localVideoElement : any
    remoteTracksAttached: boolean;
    videoHeight: any;
    videoWidth: any;
    participantConnectedPIP: boolean = true
    toasterMessageChannels: any = [];
    participantConnectedInRoom: boolean;
    timer:any
    isLocalVideoPresent: boolean;
    isZoom: boolean;
    zoomSession: any;
    zoomVideo = ZoomVideo.createClient()
    listOfParticipantInRoom :ZoomParticipant [] = [];
    isAudioStarted: boolean = false;
    camerasList: any;
    cameraStatus: boolean = true;
    isIosOrSafariInMac: boolean;
    audioEncode: boolean = false;
    audioDecode: boolean = false;
    subscription: any;
    openVideoContainerSubscription: any; // Store subscription to getOpenVideoContainer
    intervalId: any;
    // ✅ Track all setTimeout calls for proper cleanup
    private timeoutIds: any[] = [];
    // ✅ Track Zoom event listeners for proper cleanup
    private zoomEventHandlers: Map<string, (payload: any) => void> = new Map();
    // ✅ Flag to prevent operations during destruction
    private isDestroying: boolean = false;
    strictToDisconnectCall: boolean = true;
    isJoinDelayActive: boolean = false;
    isTestScreenReady: boolean = false; // Track if test screen is fully initialized
    isTestCallSessionStarting: boolean = false; // Track if testCallStartSession is currently running
    isInitializedFromNgOnInit: boolean = false; // Track if test call was initialized from ngOnInit
    private componentInstanceId: string = Math.random().toString(36).substring(7); // Unique ID for this component instance
    isScreenSharing = false;
    isParticipantScreenShareActive: boolean = false;
    isBottomPopupOpen = false;
    isScreenshareReceiverConsent: any;
    isSender: boolean = false;
    screenShareRequesterName: string | null = null;
    screenShareRecipientName: string | null = null;
    isTestVideoCall: boolean = false;
    isTestCameraOn: boolean = false;
    isTestMicOn: boolean = false;
    localTestVideoTrack: any;
    speakerTestDevices: any;
    selectedTestSpeaker: any = null;
    microphoneTestDevices: MediaDeviceInfo[];
    selectedTestMic: any;
    videoTestDevices: MediaDeviceInfo[];
    selectedTestCamera: any;
    isTestingSpeaker: any;
    speakerTester: any;
    localTestAudioTrack: any;
    microphoneTester: any;
    isTestingMicrophone: any;
    microPhoneTextContent: string = 'Test microphone';
    localAudioTrackInitlized: boolean = false;
    isMicrophoneTestInProgress = false;
    micInputLevel: number = 0;
    zoom_video_enabled: boolean;
    initials = '';
    isFirstToJoin: boolean = true;
    isLeavePopUp: boolean = false;
    authData: any;
    oppositeRole: string;
    currentCameraIndex: number = 0;
    data: any;
    channelName: any;
    nameOfparticipant: string = 'Participant';
    originalTransform: string = '';
    originalParticipantTransform: string = '';
    private maxAudioRetries: number = 8; 
    isRetryingAudio: boolean = false;
    
    // Web Audio API for enhanced noise suppression (no server headers needed)
    private audioContext: AudioContext | null = null;
    private dynamicsCompressor: DynamicsCompressorNode | null = null;
    @ViewChild('remoteVideongDraggable') remoteVideongDraggable!: ElementRef<HTMLDivElement>;

    // getUserMedia for microphone and speaker testing (not Zoom SDK)
    private userMediaStream: MediaStream | null = null;
    private audioAnalyser: AnalyserNode | null = null;
    private micAnimationFrame: number | null = null;
    private testAudioElement: HTMLAudioElement | null = null;
    private testOscillator: OscillatorNode | null = null;
    private testGainNode: GainNode | null = null;
    isBrowserSupportsVirtualBg: boolean = false;
    private pipWindow: Window | null = null; // Store reference to PIP window
    private currentRenderingUserId: number | null = null; // Track which user's video is currently being rendered
    private videoRenderTimeout: any = null; // Track setTimeout for video rendering



    constructor( private renderer: Renderer2, private mentoringEvents:MentoringEvents,
                public utility: UtilityHelper,private socketService: MentoringSocketService,
                private mentoringService: MentoringServices,private translate: TranslateService,
                private messagingHelper: MessagingHelper, private toastr: ToastsManager,
                private videoChatService: VideoChatService,private ngZone: NgZone, private router: Router, private spinner: BaThemeSpinner,
                private dialog: MatDialog, private cdr: ChangeDetectorRef) {
                super();
            }

    @HostListener('document:leavepictureinpicture', ['$event'])
    onLeavePictureInPicture(event: Event): void {
        this.showModal();
    }
    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler(event: Event) {
        if (this.isVideoLive) {
            this.disconnectFromZoomRoom();
        }
    }

    /**
     * Helper method to track setTimeout calls for proper cleanup
     */
    private trackedSetTimeout(callback: () => void, delay: number): ReturnType<typeof setTimeout> {
        const timeoutId = setTimeout(() => {
            // Remove from tracking array when executed
            const index = this.timeoutIds.indexOf(timeoutId as any);
            if (index > -1) {
                this.timeoutIds.splice(index, 1);
            }
            if (!this.isDestroying) {
                callback();
            }
        }, delay);
        this.timeoutIds.push(timeoutId as any);
        return timeoutId;
    }

    /**
     * Helper method to log video call errors to Bugsnag with comprehensive context
     */
    private logVideoCallError(error: any, stage: string, additionalContext: any = {}): void {
        try {
            const channelId = this.dataResponse?.channelId || this.utility.getItem('currentChannelId');
            const userId = this.utility.getItem('projectUserId');
            
            Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
                event.addMetadata('videoCall', {
                    stage: stage,
                    errorType: error?.name || error?.type || 'Unknown',
                    errorMessage: error?.message || error?.reason || String(error) || 'No message',
                    errorReason: error?.reason || 'No reason',
                    errorCode: error?.code || 'No code',
                    rawError: error,
                    browser: navigator.userAgent,
                    isMobile: this.utility.checkForMobile(navigator.userAgent),
                    channelId: channelId,
                    userId: userId,
                    zoomVideoEnabled: this.utility.getItem('zoom_video_enabled'),
                    isScheduleCall: this.dataResponse?.isScheduleCall || false,
                    isVideoLive: this.isVideoLive,
                    isTestVideoCall: this.isTestVideoCall,
                    isTestScreenReady: this.isTestScreenReady,
                    ...additionalContext
                });
                event.severity = 'error';
            });
        } catch (bugsnagError) {
            console.error('Failed to report error to Bugsnag:', bugsnagError);
        }
    }

    private generateInitials(firstName: string, lastName: string): string {
        if (!firstName && !lastName) return '';
        const firstInitial = firstName ? firstName[0].toUpperCase() : '';
        const lastInitial = lastName ? lastName[0].toUpperCase() : '';
        return firstInitial + lastInitial;
    }

    ngOnInit() {
        this.spinner.hide();
        const role = this.utility.getItem('role');
        this.oppositeRole = role === 'mentee' ? 'mentor' : 'mentee';
        this.isTestVideoCall = false;
        const firstNameValue = this.utility.getItem('firstName');
        const lastNameValue = this.utility.getItem('lastName');
        this.initials = this.generateInitials(firstNameValue, lastNameValue);
        this.isZoom = this.utility.getItem('zoom_video_enabled') == 'true' ? true : false;
        this.isPhoneJoined = this.utility.checkForMobile(navigator.userAgent);
        if (this.isPhoneJoined) {
            this.participantConnectedPIP = false;
        }
        
        if (this.dataResponse) {
            // Get channel data
            this.channelName = this.dataResponse.currentChannelData[0].channelName;
            const channelId = this.dataResponse.channelId;
            
            // ✅ Fetch room info to get participant names (not auth token yet) - only on initial load
            if (channelId) {
                this.fetchRoomParticipants(channelId);
            }
        }
        
        // Initialize test video call
        this.initializeTestCall();
        this.isInitializedFromNgOnInit = true; // Mark that initialization happened from ngOnInit (set BEFORE calling to prevent race condition)
        this.testCallStartSession();
    }
    
    // ✅ Separate method for test call initialization (reusable without duplicating API calls)
    private initializeTestCall() {
        this.isTestVideoCall = true;
        this.isTestScreenReady = false; // Reset ready flag when starting new test
        const videoContainer = document.getElementById('videoContainer');
        if (videoContainer) {
            videoContainer.style.display = 'none';
        }
    }
    // ✅ Fetch room info to display participant names in test screen
    private fetchRoomParticipants(channelId: string) {
        this.mentoringService.getRoomInfo(channelId).subscribe(
            (response: any) => {
                // Check if there are participants already in the room
                if (response.data && response.data.length > 0) {
                    const roomData = response.data[0];
                    const participantIds = roomData.attributes?.participant_project_user_ids || [];
                    const currentUserId = this.utility.getItem('projectUserId');
                    
                    // Check if current user is already in the room (rejoining scenario)
                    const isCurrentUserInRoom = participantIds.includes(currentUserId);
                    
                    // Check if someone else is already in the room
                    const hasOtherParticipants = participantIds.some(id => id !== currentUserId);
                    this.isFirstToJoin = !hasOtherParticipants;
                    
                    // ✅ If current user is already in the room, add slight delay with loading state (no toast)
                    if (isCurrentUserInRoom) {
                        this.ngZone.run(() => {
                            this.isJoinDelayActive = true;
                        });
                        
                        // Add 3-second delay before allowing rejoin
                        this.trackedSetTimeout(() => {
                            this.ngZone.run(() => {
                                this.isJoinDelayActive = false;
                            });
                        }, 3000);
                    }
                } else {
                    this.isFirstToJoin = true;
                }
            },
            (error) => {
                console.warn('Failed to fetch room info:', error);
                this.logVideoCallError(error, 'fetchRoomParticipants', {
                    channelId: channelId
                });
                this.isFirstToJoin = true; // Assume first to join on error
            }
        );
    }
    
    private handleAuthData(authData: any) {
        if (!authData) return;

        try {
            const accessToken = authData.data?.attributes?.access_token;
            if (!accessToken) {
                console.error('No access token found in authData');
                return;
            }

            // Decode JWT
            const payload = JSON.parse(atob(accessToken.split(".")[1]));
            const expirationDateZoomToken = new Date(payload.exp * 1000);
            const formattedTime = moment(expirationDateZoomToken).format('YYYY-MM-DD HH:mm:ss');

            const participantProjectUserIds = authData.data?.attributes?.participant_project_user_ids || [];
            const projectUserId = this.utility.getItem('projectUserId');

            // compute once and store result
            this.isFirstToJoin = !participantProjectUserIds.some(id => id !== projectUserId);

            this.utility.setItemSession('zoomTokenExpire', formattedTime);

        } catch (err) {
            console.error('Error handling authData:', err);
            this.logVideoCallError(err, 'handleAuthData', {
                hasAuthData: !!authData,
                authDataType: typeof authData
            });
        }
    }
    async connectToZooRoom() {
          // Update user agent device details in background (non-blocking)
        // Don't await - let it run separately without interrupting video call flow
        this.updateUserAgentDeviceDetails().catch(error => {
            // Silently handle errors - don't interrupt user experience
            console.error('Background update of device details failed:', error);
        });
        // ✅ Check if test screen is ready before allowing join
        if (this.isTestVideoCall && !this.isTestScreenReady) {
            this.toastr.warning('Please wait for the test screen to finish loading before joining the call.');
            return;
        }
        
        // 1️⃣ Get translations for loading messages
       await new Promise((resolve) => {
        this.translate.get('channnels').subscribe((value: any) => {
            this.toasterMessageChannels = value;
            resolve(null);
        });
        });
    
        // 2️⃣ CRITICAL: Complete any pending tests and WAIT for cleanup
        await this.completeTest();
        
        // 3️⃣ Get channel ID
        const channelId = this.dataResponse?.channelId || this.utility.getItem('currentChannelId');
        if (!channelId) {
            const error = new Error('Channel ID not found');
            this.logVideoCallError(error, 'connectToZooRoom', {
                hasDataResponse: !!this.dataResponse,
                hasCurrentChannelId: !!this.utility.getItem('currentChannelId')
            });
            this.toastr.error('Channel ID not found. Please try again.');
            return;
        }
        
        // 4️⃣ Prepare full name for identity
        const firstNameValue = this.utility.getItem('firstName');
        const lastNameValue = this.utility.getItem('lastName');
        const firstName = firstNameValue ? firstNameValue.charAt(0).toUpperCase() + firstNameValue.slice(1) : '';
        const lastName = lastNameValue ? lastNameValue.charAt(0).toUpperCase() : '';
        const fullName = `${firstName} ${lastName}.`;
    
        // 5️⃣ Prepare payload for auth token
        const payload = {
            data: {
                type: "tokens",
                attributes: {
                    channel_id: channelId,
                    identity: fullName,
                    project_user_id: this.utility.getItem('projectUserId'),
                    call_type: this.dataResponse?.isScheduleCall ? "schedule_call" : "on_demand_video_call"
                }
            }
        };
    
        // 6️⃣ Prevent joining if already live
        if (this.isVideoLive) {
            this.toastr.info(this.toasterMessageChannels.yarAlreadyInAliveVideo);
            return;
        }
        
        // 7️⃣ Show loading overlay
        const videoContainer = document.getElementById('videoContainer');
        const participantCanvas = document.getElementById('participant-videos-canvas') as HTMLCanvasElement;
        const overlay = document.getElementById('overlayParticipant')!;
        
        if (videoContainer) videoContainer.style.display = 'flex';
        if (participantCanvas) participantCanvas.style.display = 'block';
    
        this.ngZone.run(() => {
            overlay.textContent = 'Getting authorization...';
            overlay.style.backgroundColor = 'black';
        });

        await this.videoChatService.initializeCheckBlurEligibility().catch((err) => {
            console.error('Blur eligibility check failed:', err);
        });
        this.videoChatService.showBlurEligibilityToastOnCallStart();
    
        // 8️⃣ ✅ NOW get auth token (when user clicks "Join call")
        const authResponse = await this.videoChatService.getAuthToken(payload);
        
        if (!authResponse.success) {
            this.isVideoLive = false;
            this.hideModel();
            return;
        }
        
        this.authData = authResponse.data;
        
        // Handle auth data to check if first to join
        this.handleAuthData(this.authData);
        
        // Update overlay
        this.ngZone.run(() => {
            overlay.textContent = this.toasterMessageChannels.loading;
            overlay.style.backgroundColor = 'black';
        });
        
        this.zoomVideo = ZoomVideo.createClient()
        this.isTestVideoCall = false;
    
        $('#chat-section').show();
        this.mentoringEvents.setCocDisplayOrHide(true);
        $('#code-of-conduct').hide();
        
        // 9️⃣ Start Zoom session
        try {
            this.data = await this.videoChatService.startAndJoinSessionsZoom(payload, this.authData);
    
            if (!this.data) {
                console.error('Failed to join call: No session data returned');
                const error = new Error('No session data returned from startAndJoinSessionsZoom');
                this.logVideoCallError(error, 'connectToZooRoom', {
                    hasAuthData: !!this.authData,
                    authSuccess: !!authResponse.success
                });
                this.ngZone.run(() => {
                    this.toastr.error('Unable to join the call. Please try again.');
                });
                this.isVideoLive = false;
                this.hideModel();
                this.isTestVideoCall = false;
                this.mentoringEvents.setOpenVideoContainer(false);
                return;
            }
    
            this.isVideoLive = this.data.liveRoom !== null;
            this.utility.setItem('isVideCallLive', this.isVideoLive);
    
            if (this.isVideoLive) {
                this.toastr.success(this.toasterMessageChannels.youAreCurrentlyInALiveVideoCallEnjoyYourConversation);
    
                if (this.utility.getItem('zoom_video_enabled') === 'true') {
                    this.zoomSession = this.data;
                    if (participantCanvas) participantCanvas.style.display = 'block';
                    await this.zoomStartSession(this.data);
                }
            } else {
                console.error('Failed to join call: isVideoLive is false');
                const error = new Error('isVideoLive is false after session start');
                this.logVideoCallError(error, 'connectToZooRoom', {
                    hasSessionData: !!this.data,
                    liveRoom: this.data?.liveRoom || null
                });
                this.ngZone.run(() => {
                    this.toastr.error('Unable to join the call. Please check your connection and try again.');
                });
                this.isVideoLive = false;
                this.hideModel();
                this.isTestVideoCall = false;
                this.mentoringEvents.setOpenVideoContainer(false);
            }
    
        } catch (error: any) {
            // ✅ Improved error handling with detailed logging
            console.error('Error joining Zoom video call:', error);
            console.error('Error details:', {
                name: error?.name,
                message: error?.message,
                reason: error?.reason,
                code: error?.code,
                stack: error?.stack
            });
            
            // ✅ Report to Bugsnag for production debugging
            this.logVideoCallError(error, 'connectToZooRoom', {
                authSuccess: !!this.authData,
                sessionData: !!this.data,
                channelId: channelId
            });
            
            // Provide specific error messages based on error type
            let errorMessage = 'Unable to join the Zoom video call.';
            
            if (error?.reason) {
                errorMessage = `Unable to join call: ${error.reason}`;
            } else if (error?.message) {
                if (error.message.includes('permission') || error.message.includes('Permission')) {
                    errorMessage = 'Camera or microphone permission denied. Please allow access and try again.';
                } else if (error.message.includes('network') || error.message.includes('Network')) {
                    errorMessage = 'Network error. Please check your internet connection and try again.';
                } else if (error.message.includes('timeout') || error.message.includes('Timeout')) {
                    errorMessage = 'Connection timeout. Please try again.';
                } else {
                    errorMessage = `Unable to join call: ${error.message}`;
                }
            }
            
            this.ngZone.run(() => {
                this.toastr.error(errorMessage);
            });
            this.isVideoLive = false;
            this.hideModel();
            this.isTestVideoCall = false;
            this.mentoringEvents.setOpenVideoContainer(false);
        }
    }

    /**
     * Collect device information and update user agent device details
     * This runs in the background and does not block or interrupt the video call flow
     * Always sends API call with whatever data is available, even if some info is missing
     * All errors are caught and logged as warnings - never interrupts video call
     */
    private async updateUserAgentDeviceDetails(): Promise<void> {
        // Wrap entire function in try-catch to ensure nothing breaks video call flow
        try {
            // Get session token instead of user agent ID
            let sessionToken: string | null = null;
            try {
                sessionToken = this.utility.getItem('token') || 
                              this.authData?.data?.attributes?.access_token ||
                              this.authData?.data?.attributes?.token ||
                              null;
            } catch (error) {
                console.warn('Error getting session token:', error);
            }

            // Log if token is found or not, but continue regardless
            if (!sessionToken) {
                console.warn('Session token not found, will attempt API call anyway');
            }

            // Collect device information (non-blocking - runs in background)
            // Use try-catch to ensure we get whatever data is available even if some parts fail
            let deviceInfo: any;
            try {
                deviceInfo = await this.collectDeviceInformation();
            } catch (error) {
                console.warn('Error collecting device information, using defaults:', error);
                // Use minimal default data if collection fails completely
                deviceInfo = {
                    osName: 'Unknown',
                    osVersion: 'Unknown',
                    browserName: 'Unknown',
                    browserVersion: 'Unknown',
                    platform: 'desktop',
                    appVersionName: 'desktop',
                    deviceModel: 'Unknown',
                    audioPermission: 'granted',
                    videoPermission: 'granted',
                    metadata: {
                        locale: navigator.language || 'en-US'
                    }
                };
            }

            // Prepare payload matching the curl command structure
            // Always send with whatever data we have, even if incomplete
            let payload: any;
            try {
                payload = {
                    user_agent: {
                        os_name: deviceInfo?.osName || 'Unknown',
                        os_version: deviceInfo?.osVersion || 'Unknown',
                        browser_name: deviceInfo?.browserName || 'Unknown',
                        browser_version: deviceInfo?.browserVersion || 'Unknown',
                        platform: deviceInfo?.platform || 'desktop',
                        app_version_name: deviceInfo?.appVersionName || 'desktop',
                        device_model: deviceInfo?.deviceModel || 'Unknown',
                        audio_permission: deviceInfo?.audioPermission || 'granted',
                        video_permission: deviceInfo?.videoPermission || 'granted',
                        metadata: deviceInfo?.metadata || {
                            locale: navigator.language || 'en-US'
                        }
                    }
                };
            } catch (error) {
                console.warn('Error preparing payload, using minimal data:', error);
                // Fallback to absolute minimal payload if payload creation fails
                payload = {
                    user_agent: {
                        os_name: 'Unknown',
                        os_version: 'Unknown',
                        browser_name: 'Unknown',
                        browser_version: 'Unknown',
                        platform: 'desktop',
                        app_version_name: 'desktop',
                        device_model: 'Unknown',
                        audio_permission: 'granted',
                        video_permission: 'granted',
                        metadata: {
                            locale: navigator.language || 'en-US'
                        }
                    }
                };
            }

            // Always attempt API call with whatever data we have
            // Use session token instead of user agent ID
            // If token is not found, still attempt the call (backend will handle the error)
            const finalToken = sessionToken || 'unknown';
            
            // Call API to update device details (fire-and-forget, non-blocking)
            // Wrap in try-catch to ensure subscription errors don't break anything
            try {
                this.mentoringService.updateUserAgentDeviceDetails(finalToken, payload).subscribe(
                    (response) => {
                        // Success - log but don't do anything that could affect video call
                        console.log('User agent device details updated successfully');
                    },
                    (error) => {
                        // Log error as warning only - never interrupt user flow
                        console.warn('Failed to update user agent device details (non-blocking):', error);
                    }
                );
            } catch (error) {
                // Catch any subscription errors - just warn, never throw
                console.warn('Error initiating device details API call (non-blocking):', error);
            }
        } catch (error) {
            // Catch ALL errors at top level - ensure nothing breaks video call flow
            // Only log as warning, never throw or interrupt
            console.warn('Error in updateUserAgentDeviceDetails (non-blocking, video call continues):', error);
        }
    }

    /**
     * Get system information (browser and OS details)
     */
    private getSystemInfo() {
        let browserName = 'Unknown';
        let browserVersion = 'Unknown';
        let osName = 'Unknown';
        let osVersion = 'Unknown';

        const uaData = (navigator as any).userAgentData;

        if (uaData && uaData.brands) {
            // Filter out "Not A(Brand)" or generic labels
            const validBrand = uaData.brands.find((b: any) => b.brand && b.brand.toLowerCase() !== 'not a(brand)');
            if (validBrand) {
                browserName = validBrand.brand;
                browserVersion = validBrand.version;
            }

            // OS detection
            if (uaData.platform) {
                osName = uaData.platform;
                osVersion = 'Unknown'; // userAgentData rarely gives OS version
            }
        } else {
            // Fallback to navigator.userAgent parsing
            const ua = navigator.userAgent.toLowerCase();

            if (/edg\//i.test(ua)) {
                browserName = 'Edge';
                const match = ua.match(/edg\/([\d\.]+)/i);
                browserVersion = match ? match[1] : 'Unknown';
            } else if (/chrome|crios|crmo/i.test(ua)) {
                browserName = 'Chrome';
                const match = ua.match(/(?:chrome|crios|crmo)\/([\d\.]+)/i);
                browserVersion = match ? match[1] : 'Unknown';
            } else if (/firefox|fxios/i.test(ua)) {
                browserName = 'Firefox';
                const match = ua.match(/(?:firefox|fxios)\/([\d\.]+)/i);
                browserVersion = match ? match[1] : 'Unknown';
            } else if (/safari/i.test(ua) && !/chrome|crios|crmo|edg/i.test(ua)) {
                browserName = 'Safari';
                const match = ua.match(/version\/([\d\.]+)/i);
                browserVersion = match ? match[1] : 'Unknown';
            }

            // OS detection simplified
            if (/windows nt 10/.test(ua)) { osName = 'Windows'; osVersion = '10'; }
            else if (/mac os x (\d+)[._](\d+)/.test(ua)) {
                osName = 'Mac OS';
                const match = ua.match(/mac os x (\d+)[._](\d+)/);
                osVersion = match ? match[1] + '.' + match[2] : 'Unknown';
            } else if (/android (\d+)[._](\d+)/.test(ua)) {
                osName = 'Android';
                const match = ua.match(/android (\d+)[._](\d+)/);
                osVersion = match ? match[1] + '.' + match[2] : 'Unknown';
            } else if (/iphone os (\d+)[._](\d+)/.test(ua)) {
                osName = 'iOS';
                const match = ua.match(/iphone os (\d+)[._](\d+)/);
                osVersion = match ? match[1] + '.' + match[2] : 'Unknown';
            }
        }

        return { browserName, browserVersion, osName, osVersion };
    }

    /**
     * Collect device information from browser APIs
     * All operations are wrapped in try-catch to ensure nothing breaks
     * Returns default values if any step fails
     */
    private async collectDeviceInformation(): Promise<any> {
        // Get system info using the provided method - wrap in try-catch
        let systemInfo: any;
        try {
            systemInfo = this.getSystemInfo();
        } catch (error) {
            console.warn('Error getting system info, using defaults:', error);
            systemInfo = {
                browserName: 'Unknown',
                browserVersion: 'Unknown',
                osName: 'Unknown',
                osVersion: 'Unknown'
            };
        }
        
        const browserName = systemInfo?.browserName || 'Unknown';
        const browserVersion = systemInfo?.browserVersion || 'Unknown';
        const osName = systemInfo?.osName || 'Unknown';
        const osVersion = systemInfo?.osVersion || 'Unknown';

        // Determine platform
        const isMobile = this.utility.checkForMobile(navigator.userAgent);
        const isTablet = /tablet|ipad|playbook|silk/i.test(navigator.userAgent);
        const platform = isMobile ? 'mobile' : (isTablet ? 'tablet' : 'desktop');

        // Get device model from userAgentData if available, otherwise try to parse from userAgent
        // Wrap in try-catch to ensure it never breaks
        let deviceModel = 'Unknown';
        try {
            const uaData = (navigator as any).userAgentData;
            if (uaData && uaData.model) {
                deviceModel = uaData.model;
            } else {
                // Try to extract device model from userAgent
                const ua = navigator.userAgent;
                const deviceMatch = ua.match(/(?:iPhone|iPad|iPod|Android|Windows Phone|BlackBerry|PlayBook|BB10|Mobile|Tablet)[\s\/]?([\w\s]+)?/i);
                if (deviceMatch && deviceMatch[1]) {
                    deviceModel = deviceMatch[1].trim();
                }
            }
        } catch (error) {
            // Device model detection failed - just use default, warn and continue
            console.warn('Device model detection failed (non-blocking):', error);
        }

        // Check permissions (non-blocking - use existing permissions if available)
        // Since user is already in video call, permissions are likely already granted
        let audioPermission = 'granted'; // Default to granted since user is joining call
        let videoPermission = 'granted'; // Default to granted since user is joining call

        // Try to check permissions without blocking (optional check)
        // If permissions API is available, use it; otherwise default to granted
        // Wrap in try-catch to ensure permission checks never break the flow
        if (navigator.permissions) {
            try {
                const audioPermissionStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
                audioPermission = audioPermissionStatus.state === 'granted' ? 'granted' : 
                                audioPermissionStatus.state === 'denied' ? 'denied' : 'prompt';
            } catch (error) {
                // Permission query not supported or failed - keep default, just warn
                console.warn('Audio permission check failed, using default:', error);
            }

            try {
                const videoPermissionStatus = await navigator.permissions.query({ name: 'camera' as PermissionName });
                videoPermission = videoPermissionStatus.state === 'granted' ? 'granted' : 
                                videoPermissionStatus.state === 'denied' ? 'denied' : 'prompt';
            } catch (error) {
                // Permission query not supported or failed - keep default, just warn
                console.warn('Video permission check failed, using default:', error);
            }
        }

        // Collect metadata
        const metadata: any = {
            locale: navigator.language || navigator.languages?.[0] || 'en-US'
        };

        // Get network type if available - wrap in try-catch
        try {
            if ('connection' in navigator) {
                const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
                if (connection) {
                    metadata.network_type = connection.effectiveType || connection.type || 'unknown';
                }
            }
        } catch (error) {
            // Network detection failed - just warn, continue
            console.warn('Network type detection failed (non-blocking):', error);
        }

        // Get battery level if available - wrap in try-catch with timeout
        if ('getBattery' in navigator) {
            try {
                // Add timeout to prevent hanging
                const batteryPromise = (navigator as any).getBattery();
                const timeoutPromise = new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Battery API timeout')), 2000)
                );
                const battery = await Promise.race([batteryPromise, timeoutPromise]) as any;
                metadata.battery_level = `${Math.round(battery.level * 100)}%`;
            } catch (error) {
                // Battery API not available or failed - just warn, continue
                console.warn('Battery level detection failed (non-blocking):', error);
            }
        }

        // Get RAM details if available - wrap in try-catch
        try {
            // navigator.deviceMemory is available in Chrome/Edge (returns GB as number)
            if ('deviceMemory' in navigator) {
                const deviceMemory = (navigator as any).deviceMemory;
                if (deviceMemory) {
                    metadata.ram_gb = `${deviceMemory}GB`;
                }
            }
        } catch (error) {
            console.warn('Device memory detection failed (non-blocking):', error);
        }

        // performance.memory is available in Chrome (more detailed memory info)
        try {
            if (performance && (performance as any).memory) {
                const perfMemory = (performance as any).memory;
                // Convert bytes to MB/GB for readability
                const usedMB = Math.round(perfMemory.usedJSHeapSize / 1048576);
                const totalMB = Math.round(perfMemory.totalJSHeapSize / 1048576);
                const limitMB = Math.round(perfMemory.jsHeapSizeLimit / 1048576);
                
                metadata.js_heap_used_mb = `${usedMB}MB`;
                metadata.js_heap_total_mb = `${totalMB}MB`;
                metadata.js_heap_limit_mb = `${limitMB}MB`;
            }
        } catch (error) {
            // Memory API not available or failed - just warn, continue
            console.warn('Performance memory detection failed (non-blocking):', error);
        }

        // Detect external devices (cameras, microphones, speakers)
        // This helps identify if user is using external USB devices vs built-in
        // Wrap entire device enumeration in try-catch to ensure it never breaks
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            try {
                // Use Promise.race with timeout to ensure this doesn't hang
                const devicesPromise = navigator.mediaDevices.enumerateDevices();
                const timeoutPromise = new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Device enumeration timeout')), 3000)
                );
                
                const devices = await Promise.race([devicesPromise, timeoutPromise]) as MediaDeviceInfo[];
                
                const externalDevices: any = {
                    cameras: [],
                    microphones: [],
                    speakers: []
                };

                devices.forEach((device: MediaDeviceInfo) => {
                    const deviceInfo: any = {
                        label: device.label || 'Unknown',
                        deviceId: device.deviceId ? device.deviceId.substring(0, 20) + '...' : 'unknown', // Truncate for privacy
                        kind: device.kind
                    };

                    // Categorize devices
                    if (device.kind === 'videoinput') {
                        // Check if it's likely an external camera (USB webcam)
                        // External devices usually have descriptive labels, built-in ones are often generic
                        const isExternal = device.label && 
                                          device.label.length > 0 && 
                                          !device.label.toLowerCase().includes('built-in') &&
                                          !device.label.toLowerCase().includes('integrated') &&
                                          !device.label.toLowerCase().includes('facetime') &&
                                          !device.label.toLowerCase().includes('isight');
                        
                        deviceInfo.isExternal = isExternal;
                        externalDevices.cameras.push(deviceInfo);
                    } else if (device.kind === 'audioinput') {
                        // Check if it's likely an external microphone
                        const isExternal = device.label && 
                                          device.label.length > 0 && 
                                          !device.label.toLowerCase().includes('built-in') &&
                                          !device.label.toLowerCase().includes('integrated') &&
                                          !device.label.toLowerCase().includes('internal') &&
                                          !device.label.toLowerCase().includes('default');
                        
                        deviceInfo.isExternal = isExternal;
                        externalDevices.microphones.push(deviceInfo);
                    } else if (device.kind === 'audiooutput') {
                        // Check if it's likely an external speaker/headphone
                        const isExternal = device.label && 
                                          device.label.length > 0 && 
                                          !device.label.toLowerCase().includes('built-in') &&
                                          !device.label.toLowerCase().includes('integrated') &&
                                          !device.label.toLowerCase().includes('internal') &&
                                          !device.label.toLowerCase().includes('speakers');
                        
                        deviceInfo.isExternal = isExternal;
                        externalDevices.speakers.push(deviceInfo);
                    }
                });

                // Add summary counts to metadata
                metadata.external_devices = {
                    total_cameras: externalDevices.cameras.length,
                    external_cameras: externalDevices.cameras.filter((d: any) => d.isExternal).length,
                    total_microphones: externalDevices.microphones.length,
                    external_microphones: externalDevices.microphones.filter((d: any) => d.isExternal).length,
                    total_speakers: externalDevices.speakers.length,
                    external_speakers: externalDevices.speakers.filter((d: any) => d.isExternal).length,
                    has_external_camera: externalDevices.cameras.some((d: any) => d.isExternal),
                    has_external_microphone: externalDevices.microphones.some((d: any) => d.isExternal),
                    has_external_speaker: externalDevices.speakers.some((d: any) => d.isExternal)
                };
            } catch (error) {
                // Device enumeration failed (might need permissions first or timeout)
                // Just warn and continue - don't break anything
                console.warn('Failed to enumerate devices (non-blocking):', error);
                // Don't add error to metadata - just skip external device info
                // Video call flow continues normally
            }
        }

        // Get app version name if available (from package.json or environment)
        const appVersionName = 'desktop'; // You can get this from environment or package.json

        return {
            osName,
            osVersion,
            browserName,
            browserVersion,
            platform,
            deviceModel,
            audioPermission,
            videoPermission,
            appVersionName,
            metadata
        };
    }

    async startPictureInPicture(): Promise<void> {
        const el = document.getElementById('video-call-view-local') as HTMLElement;
        if (el) {
            el.style.transform = this.originalTransform || 'translate(0px, 0px)';
        }
        const isSupported = 'documentPictureInPicture' in window;

        if (!isSupported) {
            console.error('Document Picture-in-Picture not supported');
            return;
        }

        // prevent multiple PiP windows
        if ((window as any).documentPictureInPicture?.window) {
            console.warn('A PiP window is already open.');
            return;
        }

        try {
            const pipWindow = await (window as any).documentPictureInPicture.requestWindow({
                height: 240,
                width: 320,
            });

            // ✅ Store reference to PIP window for notifications
            this.pipWindow = pipWindow;

            const mainDocument = window.document;
            const pipDocument = pipWindow.document;

            // ✅ Decide which video container to move - store the state at PIP start time
            const wasParticipantConnectedAtPipStart = this.participantConnectedInRoom;
            const videoContainer = wasParticipantConnectedAtPipStart
                ? (mainDocument.querySelector('#remote') as HTMLElement)
                : (mainDocument.querySelector('#video-call-view-local') as HTMLElement);

            if (!videoContainer) {
                console.warn('No video container found for PiP.');
                return;
            }

            // ✅ Store the original parent container for restoration
            const originalParent = videoContainer.parentElement;

            // ✅ Move the element into PiP window
            pipDocument.body.appendChild(videoContainer);

            // ✅ Apply one-time clean styling
            const style = pipDocument.createElement('style');
            style.textContent = `
            html, body {
              margin: 0;
              padding: 0;
              overflow: hidden;
              background-color: black;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
            }
            #video-call-view-local, #remote, video, canvas {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              display: block;
            }
          `;
            pipDocument.head.appendChild(style);
            this.hideModel();

            // ✅ Return element to original parent when PiP closes
            // ✅ Fix: Restore based on what was actually moved to PIP, not current state
            pipWindow.addEventListener('pagehide', () => {
                // Clear PIP window reference when closing
                this.pipWindow = null;
                this.showModal();
                
                // Restore the video container to its original parent
                if (originalParent && videoContainer && videoContainer.parentElement !== originalParent) {
                    originalParent.appendChild(videoContainer);
                } else if (!originalParent) {
                    // Fallback: restore based on what was moved to PIP
                    if (wasParticipantConnectedAtPipStart) {
                        const parentContainerRemote = mainDocument.querySelector('#remote-videoTrack-container');
                        if (parentContainerRemote && videoContainer) {
                            parentContainerRemote.appendChild(videoContainer);
                        }
                    } else {
                        const parentContainerLocal = mainDocument.querySelector('#local-videoTrack-container');
                        if (parentContainerLocal && videoContainer) {
                            parentContainerLocal.appendChild(videoContainer);
                        }
                    }
                }

                // ✅ Handle case where participant joined while in PIP mode
                // If participant joined during PIP, ensure remote video is properly rendered
                if (!wasParticipantConnectedAtPipStart && this.participantConnectedInRoom) {
                    // Participant joined while in PIP - ensure remote video structure is correct
                    const remoteVideoTrackContainer = mainDocument.querySelector('#remote-videoTrack-container') as HTMLElement;
                    const remoteContainer = mainDocument.querySelector('#remote') as HTMLElement;
                    const participantCanvas = mainDocument.querySelector('#participant-videos-canvas') as HTMLElement;
                    
                    // Ensure remote container is in the correct parent
                    if (remoteContainer && remoteVideoTrackContainer && !remoteVideoTrackContainer.contains(remoteContainer)) {
                        remoteVideoTrackContainer.appendChild(remoteContainer);
                    }
                    
                    // Ensure participant canvas is inside remote container
                    if (participantCanvas && remoteContainer && !remoteContainer.contains(participantCanvas)) {
                        remoteContainer.appendChild(participantCanvas);
                    }
                }
            });

        } catch (error) {
            console.error('Error starting Picture-in-Picture:', error);
            this.logVideoCallError(error, 'startPictureInPicture', {
                participantConnectedInRoom: this.participantConnectedInRoom
            });
        }
    }
    
    ngAfterViewInit () {
        const el = document.getElementById('video-call-view-local') as HTMLElement;
        if (el) {
          this.originalTransform = el.style.transform || '';
        }
        this.openVideoContainerSubscription = this.mentoringEvents.getOpenVideoContainer().subscribe(item => {
            if (item) {
                if (!this.isInitializedFromNgOnInit && !this.isTestScreenReady && !this.localTestVideoTrack) {
                    this.initializeTestCall();
                    // ✅ Call testCallStartSession when video container opens (rejoin scenario)
                    // The guard in testCallStartSession will prevent duplicate calls
                    this.testCallStartSession();
                }
                const channelId = this.dataResponse?.channelId || this.utility.getItem('currentChannelId');
                // this.fetchRoomParticipants(channelId);
            }
        });
        this.subscription = this.mentoringEvents.getClosePipInWindow().subscribe(item =>{
            this.renderVideoAfterPipClose(item)
        })
        document.addEventListener('leavepictureinpicture', () => {
        this.showModal();
        });
          if (document.pictureInPictureElement && document.pictureInPictureElement.localName ==  "video") {
            document.exitPictureInPicture().then(() => {
                this.showModal();
            }).catch((error) => {
                this.logVideoCallError(error, 'exitPictureInPicture', {});
                this.toastr.error('Failed to exit PiP mode:', error);
            });
        }
        this.mentoringEvents.getIsPIP().subscribe((item) =>{
            if(item) {
                this.toggleRemotePictureInPicture();
            }
        })
    }
    private async waitForElement(selector: string, maxRetries: number = 30, retryDelay: number = 100): Promise<HTMLElement | null> {
        for (let i = 0; i < maxRetries; i++) {
            // Flush CD so @if / template hosts exist before querySelector.
            // ngZone.run alone schedules CD asynchronously; detectChanges is sync.
            this.cdr.detectChanges();
            const element = document.querySelector(selector) as HTMLElement;
            if (element && document.body.contains(element)) {
                await new Promise(res => setTimeout(res, 50));
                return element;
            }
            await new Promise(res => setTimeout(res, retryDelay));
        }
        return null;
    }
    async testCallStartSession() {
        if (this.isTestCallSessionStarting) {
            return;
        }
        
        this.isTestCallSessionStarting = true;
        
        if (this.isTestScreenReady && this.localTestVideoTrack) {
            this.isTestCallSessionStarting = false; // Reset flag since we're not proceeding
            return;
        }
        
        this.ngZone.runOutsideAngular(async() => {
        
        // ✅ CHECK CAMERA PERMISSION FIRST - microphone will be requested when user clicks mic icon
        let cameraPermissionGranted = false;
        
        try {
            // Try to get camera access to check permission
            const testStream = await navigator.mediaDevices.getUserMedia({ 
                video: true
            });
            
            // Permission granted - stop the test stream immediately
            testStream.getTracks().forEach(track => track.stop());
            cameraPermissionGranted = true;
            
        } catch (permissionError: any) {
            console.error('Camera permission check failed:', permissionError);
            
            // Determine if permission was denied
            const errorMessage = (permissionError.message || '').toLowerCase();
            const errorName = permissionError.name || '';
            
            const isPermissionError = 
                errorName === 'NotAllowedError' || 
                errorName === 'PermissionDeniedError' ||
                errorName === 'NotReadableError' ||
                errorMessage.includes('permission') ||
                errorMessage.includes('denied') ||
                errorMessage.includes('not allowed');
            
            // Log to Bugsnag
            this.logVideoCallError(permissionError, 'testCallStartSession_cameraPermission', {
                isPermissionError: isPermissionError,
                errorName: errorName,
                errorMessage: errorMessage
            });
            
            if (isPermissionError) {
                // Permission denied - show error and close
                this.ngZone.run(() => {
                    this.toastr.error('Camera permission is required for video calls. Please allow camera access in your browser settings (click the lock icon in the address bar) and try again.');
                    
                    // Close test screen
                    this.trackedSetTimeout(() => {
                        this.closeTestScreenDueToPermissionDenial();
                    }, 30);
                });
                this.isTestCallSessionStarting = false; // Reset flag before returning
                return; // Stop here - don't initialize anything
            } else {
                // Other error (device not found, etc.)
                this.ngZone.run(() => {
                    this.toastr.error('Unable to access camera. Please check your camera and try again.');
                });
                this.isTestCallSessionStarting = false; // Reset flag before returning
                return;
            }
        }
        
        // If we reach here, camera permission is granted - proceed with initialization
        if (!cameraPermissionGranted) {
            this.isTestCallSessionStarting = false; // Reset flag before returning
            return; // Safety check
        }
        
        const client = ZoomVideo.createClient();
        this.isBrowserSupportsVirtualBg = this.videoChatService.isBlurEligible();

        try {
            await client.init('en-US', 'Global', { patchJsMedia: true, enforceVirtualBackground: this.isBrowserSupportsVirtualBg, });

            let devices: MediaDeviceInfo[];
            try {
                // Use getUserMedia to get device list (not Zoom SDK)
                devices = await navigator.mediaDevices.enumerateDevices();
            } catch (deviceError: any) {
                console.error('Error enumerating media devices:', deviceError);
                this.logVideoCallError(deviceError, 'testCallStartSession_enumerateDevices', {
                    errorName: deviceError?.name,
                    errorMessage: deviceError?.message
                });
                this.ngZone.run(() => {
                    let errorMsg = 'Unable to access media devices. Please check permissions.';
                    if (deviceError?.name === 'NotAllowedError' || deviceError?.name === 'PermissionDeniedError') {
                        errorMsg = 'Media device permission denied. Please allow access in your browser settings and try again.';
                    } else if (deviceError?.message) {
                        errorMsg = `Unable to access media devices: ${deviceError.message}`;
                    }
                    this.toastr.error(errorMsg);
                    // Mark as ready even if device enumeration fails - user can still try to join
                    this.isTestScreenReady = true;
                });
                this.isTestCallSessionStarting = false; // Reset flag before returning
                return;
            }

            // Filter and validate video input devices
            this.videoTestDevices = devices.filter((device) => device.kind === 'videoinput');
            if (this.videoTestDevices.length === 0) {
                const error = new Error('No camera devices found');
                this.logVideoCallError(error, 'testCallStartSession_noCamera', {
                    totalDevices: devices.length,
                    deviceKinds: devices.map(d => d.kind)
                });
                this.ngZone.run(() => {
                    this.toastr.error('No camera found. Please connect a camera.');
                    // Mark as ready even without camera - user can still try to join
                    this.isTestScreenReady = true;
                });
                this.isTestCallSessionStarting = false; // Reset flag before returning
                return;
            }
            this.selectedTestCamera = this.videoTestDevices[0].deviceId;

            // Filter and validate audio output devices
            this.speakerTestDevices = devices.filter((device) => device.kind === 'audiooutput');            
            // Check if browser is Safari or Firefox (they have limited audio output device enumeration support)
            const userAgent = navigator.userAgent.toLowerCase();
            const isSafari = /safari/.test(userAgent) && !/chrome|crios|crmo|edg/.test(userAgent);
            const isFirefox = /firefox|fxios/.test(userAgent);
            
            if (this.speakerTestDevices.length > 0) {
                this.selectedTestSpeaker = this.speakerTestDevices[0].deviceId;
            } else {
                // Safari and Firefox have limited support for enumerating audio output devices
                // Audio output will still work through the default device, so we suppress the warning
                if (!isSafari && !isFirefox) {
                    this.toastr.warning('No speaker devices found.');
                } else {
                    // For Safari/Firefox, audio output devices may not be enumerable but audio still works
                    // Set to null to use default audio output device
                    this.selectedTestSpeaker = null;
                    console.log('Safari/Firefox: Audio output devices not enumerable, will use default device');
                }
            }

            // Filter and validate audio input devices
            this.microphoneTestDevices = devices.filter((device) => device.kind === 'audioinput');
            if (this.microphoneTestDevices.length === 0) {
                const error = new Error('No microphone devices found');
                this.logVideoCallError(error, 'testCallStartSession_noMicrophone', {
                    totalDevices: devices.length,
                    deviceKinds: devices.map(d => d.kind)
                });
                this.ngZone.run(() => {
                    this.toastr.error('No microphone found. Please connect a mic.');
                    // Mark as ready even without microphone - user can still try to join
                    this.isTestScreenReady = true;
                });
                this.isTestCallSessionStarting = false; // Reset flag before returning
                return;
            }
            this.selectedTestMic = this.microphoneTestDevices[0].deviceId;

            // ✅ CAMERA: Create and start local video track with ZOOM SDK (blur background)
            // Permissions already checked, so this should work
            try {
                // Paint the correct preview host before wait/attach. Must detectChanges()
                // sync — ngZone.run alone schedules CD after this turn, so querySelector
                // would miss the canvas/video and leave Join stuck on Initializing.
                const supportsVirtualBg = this.videoChatService.isBlurEligible();
                this.isBrowserSupportsVirtualBg = supportsVirtualBg;
                this.cdr.detectChanges();

                const selector = supportsVirtualBg
                    ? '#local-preview-canvas'  // canvas element ID
                    : '#local-preview-video';   // video element ID

                const previewElement = await this.waitForElement(selector, 30, 150);
            
                if (!previewElement) {
                    this.ngZone.run(() => {
                        this.toastr.error('Preview element not found. Please refresh and try again.');
                        // Still unlock Join — preview host failed, call can proceed without it
                        this.isTestScreenReady = true;
                        this.isTestCallSessionStarting = false;
                    });
                    console.error('Preview element', selector, 'not found after waiting');
                    return;
                }
            
                // Small delay to ensure element is fully initialized
                await new Promise(res => setTimeout(res, 50));
            
                // Create camera track
                this.localTestVideoTrack = await ZoomVideo.createLocalVideoTrack(this.selectedTestCamera);
            
            
                // 🟩 CASE 1: Virtual background supported → use canvas + blur
                if (supportsVirtualBg) {
                    await this.localTestVideoTrack.start(previewElement as HTMLCanvasElement,{
                            imageUrl: 'blur'
                          });
                }
            
                // 🟦 CASE 2: Virtual background NOT supported → use video element directly
                else {
                    await this.localTestVideoTrack.start(previewElement as HTMLVideoElement);
                }
            
                // Sync CD so preview leaves display:none and Join unlocks without a click.
                this.isTestCameraOn = true;
                this.isTestScreenReady = true;
                this.isTestCallSessionStarting = false;
                this.cdr.detectChanges();
            
            } catch (videoError: any) {
                console.error('Camera initialization failed:', videoError);
                this.logVideoCallError(videoError, 'testCallStartSession_cameraInit', {
                    selectedCamera: this.selectedTestCamera,
                    browserSupportsVirtualBg: this.isBrowserSupportsVirtualBg,
                    errorMessage: videoError?.message
                });
                this.localTestVideoTrack = null;
                this.ngZone.run(() => {
                    let errorMsg = 'Failed to start camera preview. Please check your camera.';
                    if (videoError?.message?.includes('element not found') || videoError?.message?.includes('Preview element')) {
                        errorMsg = 'Video preview element not available. Please refresh the page and try again.';
                    }
                    this.toastr.error(errorMsg);
                    // Still mark as ready even if camera fails - user can still try to join
                    this.isTestCameraOn = false;
                    this.isTestScreenReady = true;
                    this.isTestCallSessionStarting = false;
                    this.cdr.detectChanges();
                });
            } 

            // ✅ AUDIO: Don't auto-start - user will click mic icon to enable
            // Permissions already checked, microphone will start when user clicks icon
            this.isTestMicOn = false;
            this.localAudioTrackInitlized = false;

        } catch (error: any) {
            // ✅ Improved error handling with detailed logging
            console.error('Test call session setup failed:', error);
            this.logVideoCallError(error, 'testCallStartSession', {
                hasCameraPermission: cameraPermissionGranted,
                videoDevicesCount: this.videoTestDevices?.length || 0,
                audioDevicesCount: this.microphoneTestDevices?.length || 0
            });
            
            // Provide specific error messages based on error type
            let errorMessage = 'Test call session setup failed.';
            
            if (error?.name === 'NotAllowedError' || error?.name === 'PermissionDeniedError') {
                errorMessage = 'Camera or microphone permission denied. Please allow access in your browser settings and try again.';
            } else if (error?.name === 'NotFoundError' || error?.message?.includes('device')) {
                errorMessage = 'Camera or microphone not found. Please check your devices and try again.';
            } else if (error?.name === 'NotReadableError' || error?.message?.includes('readable')) {
                errorMessage = 'Camera or microphone is being used by another application. Please close other apps and try again.';
            } else if (error?.reason) {
                errorMessage = `Unable to initialize video call: ${error.reason}`;
            } else if (error?.message) {
                errorMessage = `Test call session setup failed: ${error.message}`;
            }
            
            this.ngZone.run(() => {
                this.toastr.error(errorMessage);
                // Close test screen on critical errors
                if (error?.name === 'NotAllowedError' || error?.name === 'PermissionDeniedError' || 
                    error?.name === 'NotFoundError' || error?.name === 'NotReadableError') {
                    this.trackedSetTimeout(() => {
                        this.closeTestScreenDueToPermissionDenial();
                    }, 2000);
                }
                this.isTestCallSessionStarting = false; // Reset flag after error handling
            });
        }
            });
    }

    // Helper method to close test screen when permissions are denied
    private closeTestScreenDueToPermissionDenial() {
        this.ngZone.run(async () => {
            this.isTestVideoCall = false;
            this.isTestScreenReady = false; // Reset ready flag
            this.isVideoLive = false;
            this.utility.setItem('isVideCallLive', false);
            
            // Clean up any resources
            await this.completeTest();
            
            // Hide modal and notify other components
            this.hideModel();
            this.mentoringEvents.setOpenVideoContainer(false);
            this.videoChatService.geVideoModalDataToShow(false);
        });
    }

    async toggleTestCamera() {
        if (!this.localTestVideoTrack) return;
        this.ngZone.runOutsideAngular(async() => {
        if (this.isTestCameraOn) {
            try {
                await this.localTestVideoTrack.stop(); // Stop the video track
                
                // Firefox-specific: Clear video source to ensure black background shows
                const videoEl = document.querySelector<HTMLVideoElement>('#local-preview-video');
                const canvasEl = document.querySelector<HTMLCanvasElement>('#local-preview-canvas');
                
                if (videoEl) {
                    videoEl.srcObject = null;
                    videoEl.load(); // Reload to clear any cached frames
                }
                if (canvasEl) {
                    try {
                        const ctx = canvasEl.getContext('2d');
                        if (ctx) {
                            ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
                            ctx.fillStyle = '#000';
                            ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);
                        }
                    } catch (error: any) {
                        // Canvas may have been transferred to offscreen by Zoom SDK (for virtual backgrounds)
                        // Cannot get context from offscreen canvas - this is expected and safe to ignore
                        if (error?.name === 'InvalidStateError' && error?.message?.includes('transferred its control to offscreen')) {
                            // Expected when canvas is used for virtual background - no action needed
                        } else {
                            throw error; // Re-throw if it's a different error
                        }
                    }
                }
            } catch (error: any) {
                // Handle VideoNotStartedError gracefully - track may already be stopped
                const isVideoNotStartedError = error?.name === 'Error' && 
                                              (error?.message === 'VideoNotStartedError' || 
                                               error?.message?.includes('VideoNotStartedError') ||
                                               error?.message?.includes('not started'));
                
                // VideoNotStartedError is expected when track is already stopped - silently handle
            }
            this.ngZone.run(() => {
                this.isTestCameraOn = false;
            });
        } else {
            const selector = this.isBrowserSupportsVirtualBg
                ? '#local-preview-canvas'
                : '#local-preview-video';
            const element = document.querySelector(selector);
            
            if (element) {
                if (this.isBrowserSupportsVirtualBg) {
                    await this.localTestVideoTrack.start(element as HTMLCanvasElement, {
                        imageUrl: 'blur'
                    });
                } else {
                    await this.localTestVideoTrack.start(element as HTMLVideoElement);
                }
                this.ngZone.run(() => {
                    this.isTestCameraOn = true;
                });
            }
        }
    });
    }
    async toggleTestMic() {
        this.ngZone.runOutsideAngular(async() => {
            // ✅ Use getUserMedia to toggle mic (not Zoom SDK)
            if (!this.userMediaStream) {
                // First time - initialize microphone
                try {
                    // Show info message to user
                    this.ngZone.run(() => {
                        this.toastr.info('Starting microphone...', '', { timeOut: 2000 });
                    });
                    
                    // Get microphone stream
                    this.userMediaStream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            deviceId: this.selectedTestMic ? { exact: this.selectedTestMic } : undefined,
                            echoCancellation: true,
                            noiseSuppression: true,
                            autoGainControl: true
                        }
                    });
                    
                    this.ngZone.run(() => {
                        this.isTestMicOn = true;
                        this.localAudioTrackInitlized = true;
                    });
                    
                    this.ngZone.run(() => {
                        this.toastr.success('Microphone enabled', '', { timeOut: 2000 });
                    });
                    
                } catch (error) {
                    console.error('Failed to start microphone:', error);
                    this.logVideoCallError(error, 'toggleTestMic_start', {
                        selectedMic: this.selectedTestMic,
                        hasUserMediaStream: !!this.userMediaStream
                    });
                    this.ngZone.run(() => {
                        this.toastr.error('Unable to access microphone. Please check permissions.');
                        this.isTestMicOn = false;
                        this.localAudioTrackInitlized = false;
                    });
                }
            } else {
                // Microphone already initialized - toggle mute/unmute
                const audioTracks = this.userMediaStream.getAudioTracks();
                if (audioTracks.length > 0) {
                    const newState = !audioTracks[0].enabled;
                    audioTracks[0].enabled = newState;
                    
                    this.ngZone.run(() => {
                        this.isTestMicOn = newState;
                        
                        // Show appropriate message
                        if (newState) {
                            this.toastr.info('Microphone unmuted', '', { timeOut: 1500 });
                        } else {
                            this.toastr.info('Microphone muted', '', { timeOut: 1500 });
                        }
                    });
                }
            }
        });
    }
    
    testSpeaker() {
        this.ngZone.runOutsideAngular(async() => {
            // ✅ Use custom audio file for speaker test (not oscillator)
            if (this.isTestingSpeaker) {
                // ✅ Update UI state FIRST (before stopping audio)
                this.ngZone.run(() => {
                    this.isTestingSpeaker = false;
                });
                
                // Stop speaker test
                if (this.testAudioElement) {
                    this.testAudioElement.pause();
                    this.testAudioElement.currentTime = 0;
                    this.testAudioElement = null;
                }
                return;
            }

            // ✅ Update UI state FIRST (before starting audio) - for instant feedback
            this.ngZone.run(() => {
                this.isTestingSpeaker = true;
            });

            // Start speaker test with custom audio file
            try {
                // Create audio element
                this.testAudioElement = new Audio();
                this.testAudioElement.src = 'assets/img/zoom_ringtone (2).mp3';
                this.testAudioElement.loop = true; // Loop the audio
                this.testAudioElement.volume = 0.5; // 50% volume
                
                // Set output device if supported
                if (this.selectedTestSpeaker && (this.testAudioElement as any).setSinkId) {
                    try {
                        await (this.testAudioElement as any).setSinkId(this.selectedTestSpeaker);
                    } catch (err) {
                        console.warn('Unable to set speaker device:', err);
                    }
                }
                if (!this.testAudioElement) {
                    return;
                }
                // Play the audio - handle AbortError if pause() interrupts play()
                try {
                    await this.testAudioElement.play();
                } catch (playError: any) {
                    // AbortError is expected when pause() interrupts play() - don't log to Bugsnag
                    const isAbortError = playError?.name === 'AbortError' || 
                                       playError?.message?.includes('interrupted by a call to pause');
                    
                    if (isAbortError) {
                        // User stopped the test before play() completed - this is expected
                        return; // Exit early, don't set up event listeners
                    } else {
                        // Re-throw unexpected errors
                        throw playError;
                    }
                }
                
                // Handle audio end (if not looping)
                this.testAudioElement.addEventListener('ended', () => {
                    if (this.isTestingSpeaker) {
                        this.testAudioElement?.play().catch((replayError: any) => {
                            // Handle AbortError on replay as well
                            const isAbortError = replayError?.name === 'AbortError' || 
                                               replayError?.message?.includes('interrupted by a call to pause');
                            // AbortError is expected when pause interrupts play - silently handle
                        });
                    }
                });
                
                // Handle errors
                this.testAudioElement.addEventListener('error', () => {
                    const mediaError = this.testAudioElement?.error;

                    const errorDetails = {
                        code: mediaError?.code,
                        message:
                            mediaError?.code === 1 ? 'Playback aborted' :
                                mediaError?.code === 2 ? 'Network error while loading audio' :
                                    mediaError?.code === 3 ? 'Audio decoding failed' :
                                        mediaError?.code === 4 ? 'Audio source not supported' :
                                            'Unknown media error'
                    };

                    const error = new Error(errorDetails.message);
                    this.logVideoCallError(error, 'testSpeaker_playback', {
                        selectedSpeaker: this.selectedTestSpeaker,
                        audioSrc: this.testAudioElement?.src,
                        mediaErrorCode: errorDetails.code
                    });

                    this.ngZone.run(() => {
                        this.toastr.error('Failed to play test audio. Please check your speaker.');
                        this.isTestingSpeaker = false;
                    });
                });

                
            } catch (error: any) {
                // Check if this is an AbortError (expected when pause interrupts play)
                const isAbortError = error?.name === 'AbortError' || 
                                   error?.message?.includes('interrupted by a call to pause');
                
                if (isAbortError) {
                    // AbortError is expected when pause() interrupts play() - don't log to Bugsnag
                    this.ngZone.run(() => {
                        this.isTestingSpeaker = false;
                    });
                } else {
                    // Log unexpected errors
                    console.error('Speaker test error:', error);
                    this.logVideoCallError(error, 'testSpeaker', {
                        selectedTestSpeaker: this.selectedTestSpeaker,
                        isTestingSpeaker: this.isTestingSpeaker
                    });
                    this.ngZone.run(() => {
                        this.toastr.error('Unable to test speaker. Please check your audio settings.');
                        this.isTestingSpeaker = false;
                    });
                }
            }
        });
    }

    async testMicrophone() {
        this.ngZone.runOutsideAngular(async () => {
            // ✅ Use getUserMedia with Web Audio API analyser (not Zoom SDK)
            if (this.isMicrophoneTestInProgress) {
                return; // Prevent rapid clicks
            }

            this.isMicrophoneTestInProgress = true;

            try {
                if (this.isTestingMicrophone) {
                    // 🔹 Stop microphone test
                    if (this.micAnimationFrame) {
                        cancelAnimationFrame(this.micAnimationFrame);
                        this.micAnimationFrame = null;
                    }
                    
                    if (this.audioAnalyser) {
                        this.audioAnalyser.disconnect();
                        this.audioAnalyser = null;
                    }
                    
                    if (this.audioContext) {
                        this.audioContext.close();
                        this.audioContext = null;
                    }

                    this.isTestingMicrophone = false;
                    this.microPhoneTextContent = 'Test microphone';
                    this.micInputLevel = 0;

                } else {
                    // 🔹 Start microphone test with getUserMedia
                    if (!this.userMediaStream) {
                        // Initialize microphone if not already done
                        try {
                            this.userMediaStream = await navigator.mediaDevices.getUserMedia({
                                audio: {
                                    deviceId: this.selectedTestMic ? { exact: this.selectedTestMic } : undefined,
                                    echoCancellation: true,
                                    noiseSuppression: true,
                                    autoGainControl: true
                                }
                            });
                            this.isTestMicOn = true;
                            this.localAudioTrackInitlized = true;
                        } catch (error) {
                            this.logVideoCallError(error, 'testMicrophone_init', {
                                selectedMic: this.selectedTestMic
                            });
                            this.toastr.error('Unable to access microphone. Please check permissions.');
                            this.isMicrophoneTestInProgress = false;
                            return;
                        }
                    }

                    // Create Web Audio API context and analyser
                    this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
                    const source = this.audioContext.createMediaStreamSource(this.userMediaStream);
                    this.audioAnalyser = this.audioContext.createAnalyser();
                    this.audioAnalyser.fftSize = 256;
                    this.audioAnalyser.smoothingTimeConstant = 0.8;
                    source.connect(this.audioAnalyser);

                    const bufferLength = this.audioAnalyser.frequencyBinCount;
                    const dataArray = new Uint8Array(bufferLength);

                    // Animate microphone input level
                    const updateLevel = () => {
                        if (!this.isTestingMicrophone) return;

                        this.audioAnalyser!.getByteFrequencyData(dataArray);
                        
                        // Calculate average volume
                        let sum = 0;
                        for (let i = 0; i < bufferLength; i++) {
                            sum += dataArray[i];
                        }
                        const average = sum / bufferLength;
                        const normalizedLevel = Math.min(100, (average / 255) * 150); // Scale to 0-100

                        this.ngZone.run(() => {
                            this.micInputLevel = Math.round(normalizedLevel);
                        });

                        this.micAnimationFrame = requestAnimationFrame(updateLevel);
                    };

                    this.isTestingMicrophone = true;
                    this.isTestMicOn = true;
                    this.microPhoneTextContent = 'Stop microphone';
                    updateLevel();
                }
            } catch (error) {
                this.logVideoCallError(error, 'testMicrophone', {
                    isTestingMicrophone: this.isTestingMicrophone,
                    hasAudioContext: !!this.audioContext,
                    hasAudioAnalyser: !!this.audioAnalyser
                });
                this.toastr.error('Microphone test failed. Please try again.');
                console.error('Error during microphone test:', error);
            } finally {
                this.isMicrophoneTestInProgress = false;
            }
        });
    }
    
    async completeTest() {
        this.ngZone.runOutsideAngular(async () => {
            // ✅ Use custom audio file for speaker test (not oscillator)
            if (this.isTestingSpeaker) {
                // ✅ Update UI state FIRST (before stopping audio)
                this.ngZone.run(() => {
                    this.isTestingSpeaker = false;
                });
                
                // Stop speaker test
                if (this.testAudioElement) {
                    this.testAudioElement.pause();
                    this.testAudioElement.currentTime = 0;
                    this.testAudioElement = null;
                }
            }
            this.isTestVideoCall = false;
            this.isTestScreenReady = false;
            this.isTestCallSessionStarting = false; // Reset session starting flag
            this.isInitializedFromNgOnInit = false; // Reset initialization flag

            try {
                // ------------------- STOP ZOOM VIDEO TRACK -------------------
                if (this.localTestVideoTrack) {
                    if (this.isTestCameraOn) {
                        try {
                            await this.localTestVideoTrack.stop(); // Stop Zoom preview safely
                        } catch (stopError: any) {
                            const isVideoNotStartedError =
                                stopError?.message?.includes('VideoNotStartedError') ||
                                stopError?.message?.includes('not started');

                            if (!isVideoNotStartedError) throw stopError;
                        }
                    }
                    this.localTestVideoTrack = null;
                    this.isTestCameraOn = false;
                }

                // ------------------- STOP MIC & AUDIO -------------------
                if (this.micAnimationFrame) {
                    cancelAnimationFrame(this.micAnimationFrame);
                    this.micAnimationFrame = null;
                }

                if (this.userMediaStream) {
                    this.userMediaStream.getTracks().forEach(t => t.stop());
                    this.userMediaStream = null;
                }

                if (this.audioAnalyser) {
                    this.audioAnalyser.disconnect();
                    this.audioAnalyser = null;
                }

                if (this.testAudioElement) {
                    this.testAudioElement.pause();
                    this.testAudioElement.currentTime = 0;
                    this.testAudioElement.src = '';
                    this.testAudioElement = null;
                }

                if (this.audioContext) {
                    await this.audioContext.close();
                    this.audioContext = null;
                }

                this.localAudioTrackInitlized = false;
                this.isTestingSpeaker = false;
                this.isTestingMicrophone = false;
                this.microPhoneTextContent = 'Test microphone';
                this.micInputLevel = 0;

                // ------------------- RESET DEVICES -------------------
                this.selectedTestCamera = null;
                this.selectedTestSpeaker = null;
                this.selectedTestMic = null;

                this.videoTestDevices = [];
                this.microphoneTestDevices = [];
                this.speakerTestDevices = [];

                // ------------------- CLEAR PREVIEW ELEMENT -------------------
                // Clear canvas first (virtual background)
                const canvasEl = document.querySelector<HTMLCanvasElement>('#local-preview-canvas');
                if (canvasEl) {
                    try {
                        const ctx = canvasEl.getContext('2d');
                        if (ctx) ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
                    } catch (error: any) {
                        // Canvas may have been transferred to offscreen by Zoom SDK (for virtual backgrounds)
                        // Cannot get context from offscreen canvas - this is expected and safe to ignore
                        if (error?.name === 'InvalidStateError' && error?.message?.includes('transferred its control to offscreen')) {
                            // Expected when canvas is used for virtual background - no action needed
                        } else {
                            throw error; // Re-throw if it's a different error
                        }
                    }
                }

                // Clear video element (normal camera)
                const videoEl = document.querySelector<HTMLVideoElement>('#local-preview-video');
                if (videoEl) {
                    const stream = videoEl.srcObject as MediaStream | null;

                    // Stop any active tracks safely before clearing element
                    if (stream) {
                        stream.getTracks().forEach(track => track.stop());
                    }

                    videoEl.srcObject = null;
                    videoEl.src = '';
                    videoEl.load();
                }

            } catch (error) {
                console.error('Error while stopping test call session:', error);
                this.logVideoCallError(error, 'completeTest', {});
            }
        });
    }

    
    ngOnDestroy() {
        // ✅ Set flag to prevent operations during destruction
        this.isDestroying = true;
        
        // ✅ Clean up all subscriptions
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        
        if (this.openVideoContainerSubscription) {
            this.openVideoContainerSubscription.unsubscribe();
            this.openVideoContainerSubscription = null;
        }
        
        // ✅ Clear all tracked setTimeout calls
        this.timeoutIds.forEach(timeoutId => {
            clearTimeout(timeoutId);
        });
        this.timeoutIds = [];
        
        // ✅ Clear timer (if set)
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        
        // ✅ Clear interval (if set)
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        
        // ✅ Unregister all Zoom SDK event listeners
        this.zoomEventHandlers.forEach((handler, eventName) => {
            try {
                this.zoomVideo.off(eventName, handler as any);
            } catch (error) {
                // Ignore errors during cleanup
            }
        });
        this.zoomEventHandlers.clear();
        
        // ✅ Complete test call cleanup (fire and forget, but handle errors)
        if (this.isTestVideoCall) {
            this.completeTest().catch(error => {
                // Log but don't throw - we're destroying the component
                console.warn('Error completing test during destroy:', error);
            });
        }
        
        // ✅ Disconnect from Zoom room if video is live (fire and forget, but handle errors)
        if (this.isVideoLive && this.zoomVideo) {
            this.disconnectFromZoomRoom().catch(error => {
                // Log but don't throw - we're destroying the component
                console.warn('Error disconnecting from Zoom during destroy:', error);
            });
        }
        
        // ✅ Clean up getUserMedia streams
        if (this.userMediaStream) {
            this.userMediaStream.getTracks().forEach(track => track.stop());
            this.userMediaStream = null;
        }
        
        // ✅ Clean up animation frames
        if (this.micAnimationFrame) {
            cancelAnimationFrame(this.micAnimationFrame);
            this.micAnimationFrame = null;
        }
        
        // ✅ Clean up audio context
        if (this.audioContext) {
            this.audioContext.close().catch(error => {
                // Ignore errors during cleanup
            });
            this.audioContext = null;
        }
        
        // ✅ Clean up audio element
        if (this.testAudioElement) {
            this.testAudioElement.pause();
            this.testAudioElement.src = '';
            this.testAudioElement = null;
        }
        
        // ✅ Clean up Zoom SDK video track
        if (this.localTestVideoTrack) {
            try {
                this.localTestVideoTrack.stop();
            } catch (error) {
                // Ignore errors during cleanup
            }
            this.localTestVideoTrack = null;
        }
        
        // ✅ Clean up test oscillator and gain node
        if (this.testOscillator) {
            try {
                this.testOscillator.stop();
            } catch (error) {
                // Ignore errors during cleanup
            }
            this.testOscillator = null;
        }
        
        if (this.testGainNode) {
            try {
                this.testGainNode.disconnect();
            } catch (error) {
                // Ignore errors during cleanup
            }
            this.testGainNode = null;
        }
        
        // ✅ Clean up audio analyser
        if (this.audioAnalyser) {
            try {
                this.audioAnalyser.disconnect();
            } catch (error) {
                // Ignore errors during cleanup
            }
            this.audioAnalyser = null;
        }
    }

    showModal(): void {
        this.showVideModalPopUp = $('#showVideModalPopUp');
        if (this.showVideModalPopUp) {
            this.showVideModalPopUp.modal('show');
        } else {
            this.toggleRemotePictureInPicture()
        }
    }
    hideModel():void{
        this.showVideModalPopUp = $('#showVideModalPopUp');
        if(this.showVideModalPopUp){
            this.showVideModalPopUp.modal('hide');
        }
    }
    toCheckForMissedCall(){
        if (this.isMissedCall && this.isVideoLive) {
            if (this.isZoom && this.zoomVideo.getCurrentUserInfo().isHost == true) {
                try {
                    const cloudRecording = this.zoomVideo.getRecordingClient()
                    cloudRecording.stopCloudRecording()
                } catch (error) {
                    this.logVideoCallError(error, 'toCheckForMissedCall_stopRecording', {
                        isHost: true,
                        isMissedCall: this.isMissedCall,
                        isVideoLive: this.isVideoLive
                    });
                    this.toastr.error(error.reason)
                }
            }
            this.translate.get('channnels').subscribe((value: any) => {
                this.toasterMessageChannels = value;
            });
            let payload = {
                "data": {
                    "type": "rooms",
                    "id": '' + this.videoChatService.liveRoomId,
                    "attributes": {
                        "status": "missed-call"
                    }
                }
            };
            this.mentoringService.updateRoomForMissedCall(payload).subscribe(
                data => this.updateRoomForMissedCallSuccess(data),
                error => this.updateRoomForMissedCallFail(error)
            );
        }
    }

    updateRoomForMissedCallSuccess(data) {
        this.toastr.info(this.toasterMessageChannels.didnotRespondToYourCall)
        this.trackedSetTimeout(() => {
            this.disconnectFromZoomRoom();
        }, 2000); 
    }
    updateRoomForMissedCallFail (error){
        if (error && error.errors && error.errors.length) {
            if(error.errors[0].title.includes('Invalid request to update')){
                this.toastr.info(this.toasterMessageChannels.endedTheCallOnlyParticipantRemaining);
                this.disconnectFromZoomRoom();
            }else{
                this.toastr.error(error.errors[0].title)
            }
        }
    }
isClicked(){
}
    disconnectTheRemainingUserAfterFiveMinutes(){
        if(!this.participantConnectedInRoom && this.isVideoLive){
            this.disconnectFromZoomRoom();
            this.toastr.info(this.toasterMessageChannels.endedTheCallOnlyParticipantRemaining)
        }
    }
    
    renderVideoAfterPipClose(item: boolean) {
        if (item) {
            const targetVideoElement = document.getElementById("participant-videos-canvas")!;
            this.remoteVideoElementRef.nativeElement.appendChild(targetVideoElement);
        } else {
            const targetVideoElement = document.querySelector("#pipPlayer video")!;
            this.localVideoElementRef.nativeElement.appendChild(targetVideoElement);
        }
    }
    
    toggleRemotePictureInPicture() {
        this.mentoringEvents.setOpenPipInWindow(this.participantConnectedInRoom, this.data)
    }

    /**
     * ✅ Show participant disconnected message in PIP window (similar to overlayParticipant)
     * @param message - The disconnected message to display
     * @param container - The container element to add the message to (defaults to PIP body)
     */
    private showPipDisconnectedMessage(message: string, container?: HTMLElement): void {
        if (!this.pipWindow || this.pipWindow.closed) {
            return;
        }

        try {
            const pipDocument = this.pipWindow.document;
            
            // Remove existing disconnected message if any
            const existingMessage = pipDocument.getElementById('pip-disconnected-message');
            if (existingMessage) {
                existingMessage.remove();
            }

            // Create disconnected message overlay (similar to overlayParticipant)
            const disconnectedOverlay = pipDocument.createElement('div');
            disconnectedOverlay.id = 'pip-disconnected-message';
            disconnectedOverlay.textContent = message;
            disconnectedOverlay.style.cssText = `
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: black;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                font-family: Arial, sans-serif;
                z-index: 1000;
                text-align: center;
                padding: 20px;
            `;

            // Use provided container or find video container in PIP
            const targetContainer = container || pipDocument.querySelector('#video-call-view-local') || pipDocument.body;
            
            if (targetContainer) {
                // Ensure container has relative positioning if it's not body
                if (targetContainer !== pipDocument.body) {
                    const containerEl = targetContainer as HTMLElement;
                    if (containerEl.style.position !== 'relative' && containerEl.style.position !== 'absolute') {
                        containerEl.style.position = 'relative';
                    }
                }
                targetContainer.appendChild(disconnectedOverlay);
            } else {
                // Fallback: add to body
                pipDocument.body.appendChild(disconnectedOverlay);
            }
        } catch (error) {
            console.error('Error showing PIP disconnected message:', error);
        }
    }

    /**
     * ✅ Show notification message in main screen
     * @param message - The notification message to display
     * @param duration - How long to show the notification in milliseconds (default: 5000)
     */
    private showMainScreenNotification(message: string, duration: number = 5000): void {
        try {
            const mainDocument = window.document;
            
            // Find the video call container
            const videoContainer = mainDocument.getElementById('videoContainer') as HTMLElement;
            if (!videoContainer) {
                console.error('Video container not found');
                return;
            }
            
            // Ensure video container has relative positioning for absolute children
            if (window.getComputedStyle(videoContainer).position === 'static') {
                videoContainer.style.position = 'relative';
            }
            
            // Remove existing notification if any (to replace it)
            const existingNotification = mainDocument.getElementById('main-screen-notification');
            if (existingNotification) {
                existingNotification.remove();
            }

            // Create notification element
            const notification = mainDocument.createElement('div');
            notification.id = 'main-screen-notification';
            notification.textContent = message;
            
            // Get container dimensions for proper positioning
            const containerRect = videoContainer.getBoundingClientRect();
            const minBottom = 20; // Minimum distance from bottom of container
            const minRight = 20; // Minimum distance from right of container
            const maxNotificationWidth = Math.min(350, containerRect.width - minRight * 2);
            
            notification.style.cssText = `
                position: absolute;
                bottom: ${minBottom}px;
                right: ${minRight}px;
                background-color: rgba(0, 0, 0, 0.85);
                color: white;
                padding: 12px 20px;
                border-radius: 6px;
                font-size: 14px;
                font-family: Arial, sans-serif;
                z-index: 10000;
                width: auto;
                min-width: 200px;
                max-width: ${maxNotificationWidth}px;
                text-align: left;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                animation: slideUpNotification 0.3s ease-out;
                pointer-events: none;
                word-wrap: break-word;
                overflow-wrap: break-word;
                max-height: ${containerRect.height - minBottom * 2}px;
                overflow-y: auto;
            `;

            // Add slide-up animation if not already added
            if (!mainDocument.head.querySelector('style#main-screen-notification-style')) {
                const style = mainDocument.createElement('style');
                style.id = 'main-screen-notification-style';
                style.textContent = `
                    @keyframes slideUpNotification {
                        from { 
                            opacity: 0; 
                            transform: translateY(30px);
                        }
                        to { 
                            opacity: 1; 
                            transform: translateY(0);
                        }
                    }
                    @keyframes slideDownNotification {
                        from { 
                            opacity: 1; 
                            transform: translateY(0);
                        }
                        to { 
                            opacity: 0; 
                            transform: translateY(30px);
                        }
                    }
                `;
                mainDocument.head.appendChild(style);
            }

            // Append notification to video container instead of body
            videoContainer.appendChild(notification);

            // Auto-remove after duration
            setTimeout(() => {
                if (notification && notification.parentElement) {
                    notification.style.animation = 'slideDownNotification 0.3s ease-in';
                    setTimeout(() => {
                        if (notification && notification.parentElement) {
                            notification.remove();
                        }
                    }, 300);
                }
            }, duration);
        } catch (error) {
            console.error('Error showing main screen notification:', error);
        }
    }

    /**
     * ✅ Show notification message in PIP window
     * @param message - The notification message to display
     * @param duration - How long to show the notification in milliseconds (default: 5000)
     */
    private showPipNotification(message: string, duration: number = 5000): void {
        if (!this.pipWindow || this.pipWindow.closed) {
            return;
        }

        try {
            const pipDocument = this.pipWindow.document;
            
            // Remove existing notification if any
            const existingNotification = pipDocument.getElementById('pip-notification');
            if (existingNotification) {
                existingNotification.remove();
            }

            // Create notification element
            const notification = pipDocument.createElement('div');
            notification.id = 'pip-notification';
            notification.textContent = message;
            notification.style.cssText = `
                position: absolute;
                top: 10px;
                left: 50%;
                transform: translateX(-50%);
                background-color: rgba(0, 0, 0, 0.8);
                color: white;
                padding: 8px 16px;
                border-radius: 4px;
                font-size: 12px;
                font-family: Arial, sans-serif;
                z-index: 1000;
                max-width: 90%;
                text-align: center;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
                animation: fadeIn 0.3s ease-in;
            `;

            // Add fade-in animation
            const style = pipDocument.createElement('style');
            style.textContent = `
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
                    to { opacity: 1; transform: translateX(-50%) translateY(0); }
                }
                @keyframes fadeOut {
                    from { opacity: 1; transform: translateX(-50%) translateY(0); }
                    to { opacity: 0; transform: translateX(-50%) translateY(-10px); }
                }
            `;
            if (!pipDocument.head.querySelector('style#pip-notification-style')) {
                style.id = 'pip-notification-style';
                pipDocument.head.appendChild(style);
            }

            pipDocument.body.appendChild(notification);

            // Auto-remove after duration
            setTimeout(() => {
                if (notification && notification.parentElement) {
                    notification.style.animation = 'fadeOut 0.3s ease-out';
                    setTimeout(() => {
                        if (notification && notification.parentElement) {
                            notification.remove();
                        }
                    }, 300);
                }
            }, duration);
        } catch (error) {
            console.error('Error showing PIP notification:', error);
        }
    }

    checkEdge(event) {
        this.edge = event;
    }
    
    getProfileImg(img) {
        if (img && img.indexOf('brightside-assets') > -1) {
            img = this.IMG_SERVER_CDN + 'resize/60x60/' + img;
        }else{
            img = `../../../../assets/img/anonymous_user.png`;
        }
        return img;
    }
    switchCamera() {
        this.camerasList = this.zoomSession.getCameraList();
        if (this.camerasList.length > 1) {
            this.cameraStatus = !this.cameraStatus;
            let deviceId = this.cameraStatus ? MobileVideoFacingMode.User : MobileVideoFacingMode.Environment;
            this.zoomSession.switchCamera(deviceId);
        } else {
            this.toastr.info("There is no secondary camera available to switch to.");
        }
    }    
/// zoom start 
async zoomStartSession(zoomSession) {
    this.CheckTokenExpire();
    const userAgent = navigator.userAgent.toLowerCase();
    if ((userAgent.includes('safari') && !userAgent.includes('chrome')) || userAgent.includes('firefox')) {
        this.isIosOrSafariInMac = true; // Safari or Firefox
    }
    this.isPhoneJoined = this.utility.checkForMobile(navigator.userAgent);

    const zoomLocalVideo = document.querySelector('#zoom-local') as HTMLElement;
    const zoomSelfCanvas = document.querySelector('#my-self-view-canvas') as HTMLElement;
    const userInfo = this.zoomVideo.getCurrentUserInfo();

    console.time("zoomStartSession_total");

    try {
        // ✅ Pre-warm camera to reduce startVideo latency
        try {
            console.time("cameraWarmup");
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            stream.getTracks().forEach(track => track.stop());
            console.timeEnd("cameraWarmup");
        } catch (warmupErr) {
            console.warn("Camera warmup skipped:", warmupErr);
            this.logVideoCallError(warmupErr, 'zoomStartSession_cameraWarmup', {
                isRenderSelfViewWithVideoElement: zoomSession.isRenderSelfViewWithVideoElement()
            });
        }

        if (zoomSession.isRenderSelfViewWithVideoElement()) {
            if (zoomLocalVideo) zoomLocalVideo.style.display = 'block';

            console.time("startVideo_initial");
            await zoomSession.startVideo({
                videoElement: zoomLocalVideo,
                ...(!this.isBrowserSupportsVirtualBg ? {} : { virtualBackground: { imageUrl: 'blur' } })
            });
            console.timeEnd("startVideo_initial");

            this.isLocalVideoPresent = true;
            this.registerRoomEventsZoom(zoomSession);

            

        } else {
            if (zoomSelfCanvas) zoomSelfCanvas.style.display = 'block';

            console.time("startVideo_canvas_initial");
            await zoomSession.startVideo({
                ...(!this.isBrowserSupportsVirtualBg ? {} : { virtualBackground: { imageUrl: 'blur' } })
            });
            console.timeEnd("startVideo_canvas_initial");

            console.time("renderVideo");
            await zoomSession.renderVideo(zoomSelfCanvas, userInfo.userId, 640, 360, 0, 0, 3);
            console.timeEnd("renderVideo");

            this.isLocalVideoPresent = true;
            this.registerRoomEventsZoom(zoomSession);
        }
    } catch (error) {
        this.toastr.error(error.reason);
    }

    this.trackedSetTimeout(() => this.toCheckForMissedCall(), 300000); // 5 min
    this.trackedSetTimeout(() => { this.strictToDisconnectCall = false; }, 5000);

    // ✅ Delay cloud recording
    if (userInfo.isHost) {
        this.trackedSetTimeout(() => {
            console.time("cloudRecording");
            const cloudRecording = this.zoomVideo.getRecordingClient();
            cloudRecording.startCloudRecording()
                .catch(err => {
                    this.logVideoCallError(err, 'zoomStartSession_startCloudRecording', {
                        isHost: userInfo.isHost,
                        userId: userInfo?.userId
                    });
                    if (err.reason) {
                        this.toastr.error(err.reason);
                    }
                })
                .finally(() => console.timeEnd("cloudRecording"));
        }, 5000); // wait 5s after join
    }

    console.timeEnd("zoomStartSession_total");
}





    async registerRoomEventsZoom(zoomSession) {
        const overlay = document.getElementById('overlayParticipant')!;
        overlay.textContent = this.toasterMessageChannels.waitingForParticipant;
        overlay.style.backgroundColor = 'black';
        this.zoomVideo.getAllUser().forEach((user) => {
            if (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId && this.zoomVideo.getCurrentUserInfo().userId !== user.userId) {
                if (user.bVideoOn) {
                    zoomSession.renderVideo(
                        document.querySelector('#participant-videos-canvas'),
                        user.userId, 1920, 1080, 0, 0, 3)
                    overlay.textContent = ''
                    overlay.style.backgroundColor = '';
                } else if (user.bVideoOn == false) {
                    overlay.textContent = user.displayName;
                }
                if (user.muted == true) {
                    this.isMutedParticipant = true
                    this.nameOfparticipant = user.displayName;
                } else if (user.muted == false) {
                    this.isMutedParticipant = false
                    this.nameOfparticipant = user.displayName;
                }

                let participant: ZoomParticipant = {
                    audio: user.audio,
                    bVideoOn: user.bVideoOn,
                    displayName: user.displayName,
                    isAllowIndividualRecording: user.isAllowIndividualRecording,
                    isHost: user.isHost,
                    isManager: user.isManager,
                    isPhoneUser: user.isPhoneUser,
                    isVideoConnect: user.isVideoConnect,
                    muted: user.muted,
                    subsessionId: user.subsessionId,
                    userGuid: user.userGuid,
                    userId: user.userId
                };
                this.isMissedCall = false
                this.participantConnectedInRoom = true
                this.listOfParticipantInRoom.push(participant)
            }
        })

        // ✅ Store event handlers for proper cleanup
        const peerVideoStateChangeHandler = (payload) => this.videoStateChange(payload);
        const userAddedHandler = (payload) => this.userAdded(payload);
        const userUpdatedHandler = (payload) => this.userUpdated(payload);
        const userLeftHandler = (payload) => this.userLeft(payload);
        const sessionEndedByHostHandler = (payload) => this.sessionEndedByHost(payload);
        const mediaSdkChangeHandler = (payload) => {
            if (payload.type === 'audio' && payload.result === 'success') {
                if (payload.action === 'encode') {
                    // encode for sending audio stream (speak)
                    this.audioEncode = true
                } else if (payload.action === 'decode') {
                    // decode for receiving audio stream (hear)
                    this.audioDecode = true
                }
            }
        };
        const chatOnMessageHandler = (payload) => {
            this.ngZone.run(() => {
                if (payload.receiver.name && payload.message == 'canActiveScreenShare' &&  payload.sender.userId !== (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId)) {
                    this.isBottomPopupOpen = true;
                    this.isSender = false;
                    this.screenShareRequesterName = this.extractScreenShareRequesterName(payload);
                    this.clearScreenShareRecipientName();
                    
                    // ✅ Show notification in PIP window if active and main screen
                    const requesterName = this.screenShareRequesterName || 'Someone';
                    const notificationMessage = `📺 ${requesterName} requested screen share approval`;
                    this.showPipNotification(notificationMessage, 7000);
                    this.showMainScreenNotification(notificationMessage, 7000);
                }
                if (payload.receiver.name && payload.message == 'activeScreenShare'&&  payload.sender.userId !== (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId)) {
                    this.isScreenshareReceiverConsent = true;
                    this.isBottomPopupOpen = false;
                    this.spinner.hide();
                    this.clearScreenShareRequesterName();
                    this.clearScreenShareRecipientName();
                    this.shareScreen();
                }
                if(payload.receiver.name && payload.message == 'denyScreenShare' &&  payload.sender.userId !== (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId)) {
                    this.toastr.info(this.toasterMessageChannels.notProceedScreenSharing);
                    this.spinner.hide();
                    this.isBottomPopupOpen = false;
                    this.clearScreenShareRequesterName();
                    this.clearScreenShareRecipientName();
                }
            });
        };
        const activeShareChangeHandler = (payload) => {
            if (payload.state === 'Active') {
                this.isParticipantScreenShareActive = true;
                $('#users-screen-share-content-canvas').css({
                    'display': 'block',
                    'width': '100%',
                    'height': '100%',
                    'object-fit': 'contain',
                    'max-width': '100%',
                    'max-height': '100%'
                })
              // ✅ Use 720p for screen sharing to avoid quality downgrade warning
              zoomSession.startShareView(
                document.querySelector('#users-screen-share-content-canvas'),
                payload.userId, 1280, 720, 0, 0, 3
              )
              this.setLayoutWhileScrrenshare();
            } else if (payload.state === 'Inactive') {
                this.isParticipantScreenShareActive = false;
              zoomSession.stopShareView()
              this.resetLaoutWhileScreenShare();
            }
        };

        // ✅ Register event listeners and store handlers for cleanup
        this.zoomVideo.on('peer-video-state-change', peerVideoStateChangeHandler);
        this.zoomEventHandlers.set('peer-video-state-change', peerVideoStateChangeHandler);
        
        this.zoomVideo.on('user-added', userAddedHandler);
        this.zoomEventHandlers.set('user-added', userAddedHandler);
        
        this.zoomVideo.on('user-updated', userUpdatedHandler);
        this.zoomEventHandlers.set('user-updated', userUpdatedHandler);
        
        this.zoomVideo.on('user-removed', userLeftHandler);
        this.zoomEventHandlers.set('user-removed', userLeftHandler);
        
        this.zoomVideo.on('connection-change', sessionEndedByHostHandler);
        this.zoomEventHandlers.set('connection-change', sessionEndedByHostHandler);
        
        // event listener to see when desktop Safari has initialized audio
        this.zoomVideo.on('media-sdk-change', mediaSdkChangeHandler);
        this.zoomEventHandlers.set('media-sdk-change', mediaSdkChangeHandler);
        
        this.zoomVideo.on('chat-on-message', chatOnMessageHandler);
        this.zoomEventHandlers.set('chat-on-message', chatOnMessageHandler);
        
        await this.initializeAudioWithRetry();     
        this.isAudioStarted = true;
        this.isMuted = false

        this.zoomVideo.on('active-share-change', activeShareChangeHandler);
        this.zoomEventHandlers.set('active-share-change', activeShareChangeHandler);
        
        // ✅ Check for existing active screen shares during initialization
        this.checkAndSubscribeToActiveScreenShares(zoomSession);


    }

    attachRemoteZoom(userVideo, videoPlayerContainer) {
        const overlay = document.getElementById('overlayParticipant')!;
        if (videoPlayerContainer && userVideo) {
            videoPlayerContainer.appendChild(userVideo);
            this.renderer.setStyle(videoPlayerContainer, 'width', '100%');
            const videoplayer = videoPlayerContainer.querySelector('video-player')
            this.renderer.setStyle(videoplayer, 'height', 'auto');
            this.renderer.setStyle(videoplayer, 'width', '100%');
            this.renderer.setStyle(videoplayer, 'aspect-ratio', '16/9');
            this.renderer.setStyle(videoPlayerContainer, 'overflow', 'hidden');
            const divElement = document.getElementById('remote')!;
            divElement.appendChild(videoPlayerContainer);
            overlay.textContent = ''
            overlay.style.backgroundColor = '';
        }
        this.isMissedCall = false
        this.participantConnectedInRoom = true
    }

    userAdded(user) {
        if (user && user.length) {
            user.forEach((userInfo) => {
                let participant: ZoomParticipant = {
                    audio: userInfo.audio,
                    bVideoOn: userInfo.bVideoOn,
                    displayName: userInfo.displayName,
                    isAllowIndividualRecording: userInfo.isAllowIndividualRecording,
                    isHost: userInfo.isHost,
                    isManager: userInfo.isManager,
                    isPhoneUser: userInfo.isPhoneUser,
                    isVideoConnect: userInfo.isVideoConnect,
                    muted: userInfo.muted,
                    subsessionId: userInfo.subsessionId,
                    userGuid: userInfo.userGuid,
                    userId: userInfo.userId
                };
                this.listOfParticipantInRoom.push(participant)
                
                // ✅ Show notification in PIP window and main screen when participant joins
                const participantName = participant.displayName || 'Participant';
                const notificationMessage = `👤 ${participantName} joined the call`;
                if (this.pipWindow && !this.pipWindow.closed) {
                    this.showPipNotification(notificationMessage, 5000);
                }
                this.showMainScreenNotification(notificationMessage, 5000);
            })
            this.isMissedCall = false
            this.participantConnectedInRoom = true
            
            // ✅ Fix: Ensure remote video container is in main document when PIP is active
            // This prevents video rendering issues when participant joins/disconnects/rejoins in PIP mode
            if (this.pipWindow && !this.pipWindow.closed) {
                const mainDocument = window.document;
                const remoteVideoTrackContainer = mainDocument.querySelector('#remote-videoTrack-container') as HTMLElement;
                const remoteContainer = mainDocument.querySelector('#remote') as HTMLElement;
                const participantCanvas = mainDocument.querySelector('#participant-videos-canvas') as HTMLElement;
                
                // Ensure remote container is in the correct parent (main document, not PIP)
                if (remoteContainer && remoteVideoTrackContainer && !remoteVideoTrackContainer.contains(remoteContainer)) {
                    remoteVideoTrackContainer.appendChild(remoteContainer);
                }
                
                // Ensure participant canvas is inside remote container in main document
                if (participantCanvas && remoteContainer && !remoteContainer.contains(participantCanvas)) {
                    remoteContainer.appendChild(participantCanvas);
                }
            }
            
            // ✅ Fix: Check for active screen shares when user is added (handles reconnection scenario)
            // This ensures that when a user reconnects, they can see any active screen shares
            if (this.zoomSession) {
                this.checkAndSubscribeToActiveScreenShares(this.zoomSession);
            }
        }
    }

    userUpdated(user) {
        const overlay = document.getElementById('overlayParticipant');
        try {
            if (user && user.length && overlay) {
                user.forEach(userUpdate => {
                    if (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId && this.zoomVideo.getCurrentUserInfo().userId !== userUpdate.userId) {
                        const participant = this.listOfParticipantInRoom.find(participant => participant.userId === userUpdate.userId);
                        if (participant) {
                            if (userUpdate.bVideoOn == false) {
                                overlay.textContent = participant.displayName;
                            } else if (userUpdate.bVideoOn == true) {
                                overlay.textContent = '';
                            }
                            this.ngZone.run(() => {
                                if (userUpdate.muted == true) {
                                    this.isMutedParticipant = true
                                    this.nameOfparticipant = participant.displayName;
                                } else if (userUpdate.muted == false) {
                                    this.isMutedParticipant = false;
                                    this.nameOfparticipant = participant.displayName;
                                }
                            });
                        }
                    }
                });
            }
        } catch (error) {
            this.toastr.error(error.reason)
        }
    }

    userLeft(user) {
        if (user && user.length) {
            user.forEach((userUpdate) => {
                if (this.zoomVideo.getCurrentUserInfo() && this.zoomVideo.getCurrentUserInfo().userId && this.zoomVideo.getCurrentUserInfo().userId != userUpdate.userId) {
                    const mainDocument = window.document;
                    const overlay = mainDocument.getElementById('overlayParticipant')!;
                    overlay.textContent = this.toasterMessageChannels.participantDisconnected;
                    overlay.style.backgroundColor = 'black';
                    this.participantConnectedInRoom = false
                    clearTimeout(this.timer);
                        this.timer = this.trackedSetTimeout(() => {
                            this.disconnectTheRemainingUserAfterFiveMinutes();
                        }, 300000);
                    const participant = this.listOfParticipantInRoom.find(participant => participant.userId === userUpdate.userId);
                    
                    // ✅ Show notification in main screen when participant disconnects
                    if (participant) {
                        const participantName = participant.displayName || 'Participant';
                        const notificationMessage = `👋 ${participantName} left the call`;
                        this.showMainScreenNotification(notificationMessage, 5000);
                    }
                    
                    // ✅ Handle participant disconnect in PIP mode
                    if (this.pipWindow && !this.pipWindow.closed) {
                        const pipDocument = this.pipWindow.document;
                        const remoteInPip = pipDocument.querySelector('#remote') as HTMLElement;
                        
                        // Check if remote container is in PIP window
                        if (remoteInPip) {
                            // Stop video rendering first
                            try {
                                const participantCanvas = remoteInPip.querySelector('#participant-videos-canvas') as HTMLElement;
                                if (participantCanvas && this.zoomSession && userUpdate.userId) {
                                    this.zoomSession.stopRenderVideo(participantCanvas, userUpdate.userId);
                                }
                                // Clear tracking
                                if (this.currentRenderingUserId === userUpdate.userId) {
                                    this.currentRenderingUserId = null;
                                }
                            } catch (error) {
                                console.warn('Error stopping video render during disconnect:', error);
                            }
                            
                            // Move remote container back to main document
                            const remoteVideoTrackContainer = mainDocument.querySelector('#remote-videoTrack-container') as HTMLElement;
                            if (remoteVideoTrackContainer && remoteInPip) {
                                remoteVideoTrackContainer.appendChild(remoteInPip);
                                
                                // Ensure overlayParticipant is visible in main document
                                const overlayInMain = mainDocument.getElementById('overlayParticipant');
                                if (overlayInMain) {
                                    overlayInMain.textContent = this.toasterMessageChannels.participantDisconnected;
                                    overlayInMain.style.backgroundColor = 'black';
                                }
                            }
                            
                            // Show disconnected message in PIP window (similar to overlayParticipant)
                            // Use local video container if remote was moved back
                            const localVideoInPip = pipDocument.querySelector('#video-call-view-local') as HTMLElement;
                            const containerToShowMessage = localVideoInPip || pipDocument.body;
                            this.showPipDisconnectedMessage(this.toasterMessageChannels.participantDisconnected, containerToShowMessage);
                            
                            // Show notification
                            if (participant) {
                                const participantName = participant.displayName || 'Participant';
                                const notificationMessage = `👋 ${participantName} left the call`;
                                this.showPipNotification(notificationMessage, 5000);
                                this.showMainScreenNotification(notificationMessage, 5000);
                            }
                        } else {
                            // Remote container is already in main document, just show notification
                            if (participant) {
                                const participantName = participant.displayName || 'Participant';
                                const notificationMessage = `👋 ${participantName} left the call`;
                                this.showPipNotification(notificationMessage, 5000);
                                this.showMainScreenNotification(notificationMessage, 5000);
                            }
                        }
                    }
                    
                    if (participant) {
                        // Find the index of the element to remove
                        let index = this.listOfParticipantInRoom.indexOf(participant);
                        if (index !== -1) {
                            this.listOfParticipantInRoom.splice(index, 1);
                        }
                    }
                }
            })
        }
    }

    videoStateChange(videoState) {
        try {
            // ✅ Fix: Ensure canvas is in main document when PIP is active
            // This prevents video freezing when participant rejoins in PIP mode
            const mainDocument = window.document;
            let participantCanvas = mainDocument.querySelector('#participant-videos-canvas') as HTMLElement;
            
            // If PIP is active, ensure canvas is in main document, not PIP window
            if (this.pipWindow && !this.pipWindow.closed && participantCanvas) {
                const remoteContainer = mainDocument.querySelector('#remote') as HTMLElement;
                const remoteVideoTrackContainer = mainDocument.querySelector('#remote-videoTrack-container') as HTMLElement;
                
                // Check if canvas is in PIP window (wrong location)
                const pipDocument = this.pipWindow.document;
                const canvasInPip = pipDocument.querySelector('#participant-videos-canvas');
                
                if (canvasInPip || (participantCanvas && !remoteContainer?.contains(participantCanvas))) {
                    // Canvas is in wrong location, move it to correct location in main document
                    if (remoteContainer && remoteVideoTrackContainer) {
                        // Ensure remote container is in main document
                        if (!remoteVideoTrackContainer.contains(remoteContainer)) {
                            remoteVideoTrackContainer.appendChild(remoteContainer);
                        }
                        // Ensure canvas is inside remote container
                        if (participantCanvas && !remoteContainer.contains(participantCanvas)) {
                            remoteContainer.appendChild(participantCanvas);
                        }
                        // Re-query to get the correct reference
                        participantCanvas = mainDocument.querySelector('#participant-videos-canvas') as HTMLElement;
                    }
                }
            }
            
            if (videoState.action === 'Start') {
                if (!participantCanvas) {
                    console.warn('Participant canvas not found for video rendering');
                    return;
                }
                
                // ✅ Fix: Prevent duplicate video subscriptions
                // If already rendering the same user, skip
                if (this.currentRenderingUserId === videoState.userId) {
                    return;
                }
                
                // Cancel any pending render timeout
                if (this.videoRenderTimeout) {
                    clearTimeout(this.videoRenderTimeout);
                    this.videoRenderTimeout = null;
                }
                
                // Stop any existing rendering first to prevent conflicts
                if (this.currentRenderingUserId !== null) {
                    try {
                        this.zoomSession.stopRenderVideo(participantCanvas, this.currentRenderingUserId);
                    } catch (stopError) {
                        console.warn('Error stopping previous video render:', stopError);
                    }
                    // Small delay to ensure cleanup before starting new render
                    this.videoRenderTimeout = setTimeout(() => {
                        this.renderParticipantVideo(participantCanvas, videoState.userId);
                        this.videoRenderTimeout = null;
                    }, 150);
                } else {
                    // No existing render, start immediately
                    this.renderParticipantVideo(participantCanvas, videoState.userId);
                }
            } else if (videoState.action === 'Stop') {
                // Cancel any pending render timeout
                if (this.videoRenderTimeout) {
                    clearTimeout(this.videoRenderTimeout);
                    this.videoRenderTimeout = null;
                }
                
                if (participantCanvas) {
                    try {
                        this.zoomSession.stopRenderVideo(
                            participantCanvas,
                            videoState.userId
                        );
                        // Clear tracking if this was the current rendering user
                        if (this.currentRenderingUserId === videoState.userId) {
                            this.currentRenderingUserId = null;
                        }
                    } catch (stopError) {
                        console.warn('Error stopping video render:', stopError);
                    }
                }
            }
        } catch (error) {
            console.error('Error in videoStateChange:', error);
            this.toastr.error(error.reason || 'Video rendering error')
        }
    }

    /**
     * ✅ Helper method to render participant video
     * Prevents duplicate subscriptions by tracking current rendering user
     */
    private renderParticipantVideo(canvas: HTMLElement, userId: number): void {
        try {
            // Double-check we're not already rendering this user
            if (this.currentRenderingUserId === userId) {
                return;
            }
            
            // Stop any existing render first
            if (this.currentRenderingUserId !== null) {
                try {
                    this.zoomSession.stopRenderVideo(canvas, this.currentRenderingUserId);
                } catch (stopError) {
                    // Ignore errors when stopping
                }
            }
            
            // Start rendering
            this.zoomSession.renderVideo(
                canvas,
                userId, 1920, 1080, 0, 0, 3
            );
            
            // Track current rendering user
            this.currentRenderingUserId = userId;
            
            const overlay = document.getElementById('overlayParticipant');
            if (overlay) {
                overlay.textContent = '';
                overlay.style.backgroundColor = '';
            }
            this.isMissedCall = false;
        } catch (error) {
            console.error('Error rendering participant video:', error);
            this.currentRenderingUserId = null; // Reset on error
            throw error;
        }
    }

    sessionEndedByHost(sessionState) {

    }
    detachRemoteZoom(userVideo, userId) {
        const videoPlayerContainer = document.querySelector('video-player-container')!;
        userVideo.detachVideo(userId)
        videoPlayerContainer.remove();
    }
    detachLocalZoom() {

    }

    /**
     * ✅ Exit PIP mode and restore video containers before disconnect
     * This prevents video freezing and white window issues
     */
    private async exitPipModeBeforeDisconnect(): Promise<void> {
        if (!this.pipWindow || this.pipWindow.closed) {
            return;
        }

        try {
            const mainDocument = window.document;
            const pipDocument = this.pipWindow.document;
            
            // Find video containers in PIP
            const remoteInPip = pipDocument.querySelector('#remote') as HTMLElement;
            const localInPip = pipDocument.querySelector('#video-call-view-local') as HTMLElement;
            
            // Stop any video rendering before moving containers
            if (this.currentRenderingUserId !== null && this.zoomSession) {
                try {
                    const participantCanvas = remoteInPip?.querySelector('#participant-videos-canvas') as HTMLElement;
                    if (participantCanvas) {
                        this.zoomSession.stopRenderVideo(participantCanvas, this.currentRenderingUserId);
                    }
                } catch (error) {
                    // Ignore errors when stopping video render
                }
            }
            
            // Restore remote container if it's in PIP
            if (remoteInPip) {
                const remoteVideoTrackContainer = mainDocument.querySelector('#remote-videoTrack-container') as HTMLElement;
                if (remoteVideoTrackContainer) {
                    remoteVideoTrackContainer.appendChild(remoteInPip);
                }
            }
            
            // Restore local container if it's in PIP
            if (localInPip) {
                const localVideoTrackContainer = mainDocument.querySelector('#local-videoTrack-container') as HTMLElement;
                if (localVideoTrackContainer) {
                    localVideoTrackContainer.appendChild(localInPip);
                }
            }
            
            // Ensure participant canvas is in correct location if remote was restored
            if (remoteInPip) {
                const remoteContainer = mainDocument.querySelector('#remote') as HTMLElement;
                const participantCanvas = mainDocument.querySelector('#participant-videos-canvas') as HTMLElement;
                if (participantCanvas && remoteContainer && !remoteContainer.contains(participantCanvas)) {
                    remoteContainer.appendChild(participantCanvas);
                }
            }
            
            // Close PIP window
            try {
                this.pipWindow.close();
            } catch (closeError) {
                // PIP window might already be closing
            }
            this.pipWindow = null;
            
            // Show modal back
            this.showModal();
            
            // Small delay to ensure containers are restored and DOM is updated
            await new Promise(resolve => setTimeout(resolve, 150));
        } catch (error) {
            console.error('Error exiting PIP mode before disconnect:', error);
            // Force close PIP window even if restore fails
            if (this.pipWindow && !this.pipWindow.closed) {
                try {
                    this.pipWindow.close();
                } catch (closeError) {
                    console.warn('Error closing PIP window:', closeError);
                }
                this.pipWindow = null;
            }
            // Show modal back even on error
            this.showModal();
        }
    }

    async disconnectFromZoomRoom() {
        try {
            // ✅ First exit PIP mode if active (restore containers before disconnect)
            await this.exitPipModeBeforeDisconnect();
            
            // ✅ Clean up video rendering state
            if (this.videoRenderTimeout) {
                clearTimeout(this.videoRenderTimeout);
                this.videoRenderTimeout = null;
            }
            
            // Stop any active video rendering
            if (this.currentRenderingUserId !== null && this.zoomSession) {
                try {
                    const participantCanvas = document.querySelector('#participant-videos-canvas') as HTMLElement;
                    if (participantCanvas) {
                        this.zoomSession.stopRenderVideo(participantCanvas, this.currentRenderingUserId);
                    }
                } catch (error) {
                    // Ignore errors when stopping video render during disconnect
                    console.warn('Error stopping video render during disconnect:', error);
                }
                this.currentRenderingUserId = null;
            }
            
            this.spinner.show();
            this.isVideoLive = false;
            this.utility.setItem('isVideCallLive', false);

            if (!this.isMissedCall) {
                const currentUser = this.zoomVideo.getCurrentUserInfo();
                if (currentUser?.isHost) {
                    try {
                        const cloudRecording = this.zoomVideo.getRecordingClient();
                        await cloudRecording.stopCloudRecording();
                    } catch (error) {
                        this.logVideoCallError(error, 'disconnectFromZoomRoom_stopRecording', {
                            isHost: currentUser?.isHost,
                            isMissedCall: this.isMissedCall
                        });
                        this.toastr.error(error?.reason || 'Failed to stop recording');
                    }
                }
            }

            // ✅ Stop local media streams
            const mediaStream = this.zoomVideo.getMediaStream();
            if (mediaStream) {
                try {
                    await mediaStream.stopVideo();
                } catch (error) {
                    // Handle "camera is closed" error gracefully - this is expected when camera is already stopped
                    const isCameraClosedError = (error?.type === 'INVALID_OPERATION' &&
                        (error?.reason === 'camera is closed' || error?.message?.includes('camera is closed') || error?.message?.includes('closed'))
                    ) ||
                        (
                            error?.type === 'IMPROPER_MEETING_STATE' &&
                            error?.reason === 'closed'
                        );
                    if (!isCameraClosedError) {
                        this.logVideoCallError(error, 'disconnectFromZoomRoom_stopMedia', {
                            hasMediaStream: !!mediaStream,
                            mediaType: 'video'
                        });
                    }
                }
                
                try {
                    await mediaStream.stopAudio();
                } catch (error) {
                    // Handle "audio is closed" or similar errors gracefully
                    const isClosed =
                        error?.reason?.includes('closed') || error?.message?.includes('closed');

                    const isAudioClosedError =
                        (error?.type === 'INVALID_OPERATION' || error?.type === 'IMPROPER_MEETING_STATE') &&
                        isClosed;
                        
                    if (!isAudioClosedError) {
                        this.logVideoCallError(error, 'disconnectFromZoomRoom_stopMedia', {
                            hasMediaStream: !!mediaStream,
                            mediaType: 'audio'
                        });
                    }
                }
            }

            // ✅ Properly leave the session
            await this.zoomVideo.leave();

            // ✅ Optionally clear the video element if you’re rendering locally
            //   if (document.getElementById('self-view')) {
            //     document.getElementById('self-view').innerHTML = '';
            //   }

            this.listOfParticipantInRoom = [];
            this.mentoringEvents.setOpenVideoContainer(false);

            if (!this.isMissedCall) {
                this.mentoringEvents.setDisconnetRoom(true);
            }

            this.utility.setItem('isVideoCallDisconnect', true);
            this.utility.setItem('isVideCallLive', false);
            this.mentoringEvents.setCodeOfConduct(false);
            this.hideModel();
            // this.closeVideo.emit();

        } catch (error) {
            console.error('Error during disconnect:', error);
            this.logVideoCallError(error, 'disconnectFromZoomRoom', {
                isVideoLive: this.isVideoLive,
                isMissedCall: this.isMissedCall,
                hasZoomVideo: !!this.zoomVideo
            });
        } finally {
            this.spinner.hide();
        }
    }
    isIOS() {
        const userAgent = navigator.userAgent;
        return /iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }
    async muteAndUnmuteAudio() {
        try {
            if (this.isAudioStarted) {
                if (this.isMuted) {
                    await this.zoomSession.unmuteAudio();
                } else {
                    await this.zoomSession.muteAudio();
                }
                this.isMuted = !this.isMuted;
            } else {
                await this.initializeAudioWithRetry();
            }
        } catch (error) {
            this.logVideoCallError(error, 'muteAndUnmuteAudio', {
                isAudioStarted: this.isAudioStarted,
                isMuted: this.isMuted,
                hasZoomSession: !!this.zoomSession
            });
            this.toastr.error(error.reason || 'Failed to toggle audio');
        }
    }
    private async initializeAudioWithRetry(retryCount: number = 0): Promise<void> {
                const isSafari = /safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase());
                const isMobileOrTablet = await this.utility.checkForMobile(navigator.userAgent) || this.isIOS();
                if (retryCount === 0) {
                    this.ngZone.run(() => {
                        this.isRetryingAudio = true;
                    });
                }

                if (!isMobileOrTablet && isSafari) {
                    if (!this.audioEncode || !this.audioDecode) {
                        if (retryCount < this.maxAudioRetries) {
                            await new Promise(resolve => setTimeout(resolve, 500));
                            return this.initializeAudioWithRetry(retryCount + 1);
                        } else {
                            console.warn('Safari audio initialization timeout, proceeding anyway');
                        }
                    }
                    this.isRetryingAudio = false;
                }
            try {
                // Start audio with enhanced constraints
                await this.zoomSession.startAudio({
                    originalSound: false,
                    audioConstraints: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true,
                        channelCount: 1
                    }
                });
                
                // Enable Zoom SDK noise suppression (high level)
                try {
                    if (typeof this.zoomSession.enableBackgroundNoiseSuppression === 'function') {
                        try {
                            await this.zoomSession.enableBackgroundNoiseSuppression('high');
                        } catch (e) {
                            await this.zoomSession.enableBackgroundNoiseSuppression(true);
                        }
                    } else if (typeof this.zoomSession.updateAudioSettings === 'function') {
                        await this.zoomSession.updateAudioSettings({ 
                            backgroundNoiseSuppression: 'high'
                        });
                    }
                    if (typeof this.zoomSession.enableEchoCancellation === 'function') {
                        try {
                            await this.zoomSession.enableEchoCancellation(true);
                        } catch (e) { }
                    }
                } catch (error) {
                    this.logVideoCallError(error, 'initializeAudioWithRetry_audioSettings', {
                        retryCount: retryCount,
                        isSafari: /safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase()),
                        isMobileOrTablet: await this.utility.checkForMobile(navigator.userAgent) || this.isIOS(),
                        audioEncode: this.audioEncode,
                        audioDecode: this.audioDecode
                    });                            this.toastr.error('Microphone permission is required for audio in calls. Please allow microphone access in your browser settings (click the lock icon in the address bar) and rejoin the call.');

                }

                this.isAudioStarted = true;
                this.isMuted = !this.isMuted;
                } catch (audioError: any) {
                    const errorMessage = (audioError.message || audioError.reason || '').toLowerCase();
                    const errorName = audioError.name || '';
                    const isPermissionError = 
                        errorName === 'NotAllowedError' || 
                        errorName === 'PermissionDeniedError' ||
                        errorMessage.includes('permission') ||
                        errorMessage.includes('denied') ||
                        errorMessage.includes('not allowed');
                    this.logVideoCallError(audioError, 'initializeAudioWithRetry_failed', {
                        isPermissionError: isPermissionError,
                        errorName: errorName,
                        errorMessage: errorMessage,
                        retryCount: retryCount
                    });
                    if (isPermissionError) {
                        this.ngZone.run(() => {
                            this.toastr.error('Microphone permission is required for audio in calls. Please allow microphone access in your browser settings (click the lock icon in the address bar) and rejoin the call.');
                            this.isAudioStarted = false;
                            this.isMuted = true;
                        });
                    } else {
                        this.ngZone.run(() => {
                            this.toastr.error('Unable to start audio. Please check your microphone and try again.');
                            this.isAudioStarted = false;
                            this.isMuted = true;
                        });
                    }
                    throw audioError;
                } finally {
        this.ngZone.run(() => {
            this.isRetryingAudio = false;
        });
        }
    }
    
    async muteAndUnmuteVideo() {
        this.isPhoneJoined = this.utility.checkForMobile(navigator.userAgent);
        const overlay = document.getElementById('overlay')!;
        const zoomLocalVideo = document.querySelector('#zoom-local') as HTMLElement;
        const zoomSelfCanvas = document.querySelector('#my-self-view-canvas') as HTMLElement;
        const currentUser = this.zoomVideo.getCurrentUserInfo();

        if (currentUser && currentUser.bVideoOn !== undefined) {
            try {
                if (currentUser.bVideoOn) {
                    await this.zoomSession.stopVideo();
                    overlay.style.backgroundColor = 'black';
                    overlay.style.border = '1px solid';
                    overlay.style.left = '0px';    
                    overlay.textContent = currentUser.displayName;
                } else {
                    if (this.zoomSession.isRenderSelfViewWithVideoElement()) {
                        await this.zoomSession.startVideo({
                            videoElement: zoomLocalVideo,
                            ...(!this.isBrowserSupportsVirtualBg ? {} : {  virtualBackground: { imageUrl: 'blur' }  })
                        });
                    } else {
                        await this.zoomSession.startVideo({
                            ...(!this.isBrowserSupportsVirtualBg ? {} : {  virtualBackground: { imageUrl: 'blur' }  })
                        });
                        await this.zoomSession.renderVideo(zoomSelfCanvas,currentUser.userId,1920,1080,0,0,3
                        );
                    }
                    overlay.textContent = '';
                    overlay.style.backgroundColor = '';
                }
                this.isVideoDisabled = !this.isVideoDisabled;
            } catch (error) {
                this.logVideoCallError(error, 'muteAndUnmuteVideo', {
                    currentUserVideoOn: currentUser?.bVideoOn,
                    isRenderSelfViewWithVideoElement: this.zoomSession?.isRenderSelfViewWithVideoElement(),
                    isIosOrSafariInMac: this.isIosOrSafariInMac,
                    isPhoneJoined: this.isPhoneJoined
                });
                this.toastr.error(error.reason);
            }
        } else {
            this.toastr.warning('Unable to retrieve video status');
        }
    }

    toEnablePip() {
        if(!this.isPhoneJoined) {
            return true;
        } else {
            return false;
        }
    }  
    CheckTokenExpire() {
        clearInterval(this.intervalId)
        const ExpiredTokenTime = this.utility.getItemSession('zoomTokenExpire');
        if (ExpiredTokenTime) {
            const isExpired = this.isTokenExpired(ExpiredTokenTime);
            if (isExpired) {
                return;
            }
        }

        this.intervalId = setInterval(() => {
            const isExpired = this.isTokenExpired(ExpiredTokenTime);
            if (isExpired) {
                clearInterval(this.intervalId);
                this.disconnectFromZoomRoom();
            }
        }, 300000);
    }

    isTokenExpired(expirationDate) {
        try {
            // Check if the current time is after the expiration time
            const currentTime = moment();
            const expirationTime = moment(expirationDate);

            return currentTime.isAfter(expirationTime)
        } catch (error) {
            return false;
        }
    }
    setSpeaker(speaker: string) {
        this.selectedTestSpeaker = speaker;
        
        // If speaker test is active, update the output device
        if (this.isTestingSpeaker && this.testAudioElement) {
            if ((this.testAudioElement as any).setSinkId) {
                (this.testAudioElement as any).setSinkId(speaker).catch((err: any) => {
                    console.warn('Unable to set speaker device:', err);
                    this.logVideoCallError(err, 'setSpeaker_setSinkId', {
                        speaker: speaker,
                        isTestingSpeaker: this.isTestingSpeaker
                    });
                });
            }
        }
    }
    
    async setMic(deviceId: string) {
        this.selectedTestMic = deviceId;
        
        // If microphone is active, switch to the new device
        if (this.userMediaStream && this.localAudioTrackInitlized) {
            try {
                // Stop current stream
                this.userMediaStream.getTracks().forEach(track => track.stop());
                
                // Get new stream with selected device
                this.userMediaStream = await navigator.mediaDevices.getUserMedia({
                    audio: {
                        deviceId: { exact: deviceId },
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true
                    }
                });
                
                // If microphone test is running, reconnect to analyser
                if (this.isTestingMicrophone && this.audioContext && this.audioAnalyser) {
                    const source = this.audioContext.createMediaStreamSource(this.userMediaStream);
                    source.connect(this.audioAnalyser);
                }
            } catch (error) {
                this.logVideoCallError(error, 'setMic', {
                    deviceId: deviceId,
                    hasUserMediaStream: !!this.userMediaStream,
                    isTestingMicrophone: this.isTestingMicrophone
                });
                this.toastr.error('Unable to switch microphone device.');
                console.error('Error switching microphone:', error);
            }
        }
    }
   async setCamera(deviceId: string, index ) {
    this.currentCameraIndex = index; 
        this.selectedTestCamera = deviceId;
        try {
            this.localTestVideoTrack = await ZoomVideo.createLocalVideoTrack(this.selectedTestCamera);
            await this.localTestVideoTrack.start(document.querySelector('#local-preview-video'));
            this.isTestCameraOn = true;
        } catch (videoError) {
            this.logVideoCallError(videoError, 'setCamera', {
                deviceId: deviceId,
                index: index,
                hasPreviewElement: !!document.querySelector('#local-preview-video')
            });
            this.toastr.error('Failed to start camera preview.');
            this.localTestVideoTrack = null;
            this.isTestCameraOn = false;
        }
    }
    
    async switchToCameraList() {
            if (this.videoTestDevices.length === 0) {
                console.warn('No cameras found');
                const error = new Error('No cameras found for switching');
                this.logVideoCallError(error, 'switchToCameraList_noCameras', {});
                return;
            }
            if (this.videoTestDevices.length === 1) {
                this.toastr.warning("Unable to switch — only one camera detected.")
                return;
            }
            // pick next device
            this.currentCameraIndex = (this.currentCameraIndex + 1) % this.videoTestDevices.length;
            const deviceId = this.videoTestDevices[this.currentCameraIndex].deviceId;

        try {
            this.selectedTestCamera = deviceId;
            this.setCamera(deviceId, this.currentCameraIndex)

        } catch (err) {
            console.error('Error accessing camera', err);
            this.logVideoCallError(err, 'switchToCameraList', {
                currentCameraIndex: this.currentCameraIndex,
                deviceId: deviceId,
                totalCameras: this.videoTestDevices.length
            });
        }
    }

    async cancelTestCall() {
        if (this.isTestingSpeaker) {
            this.ngZone.run(() => {
                this.isTestingSpeaker = false;
            });

            // Stop speaker test
            if (this.testAudioElement) {
                this.testAudioElement.pause();
                this.testAudioElement.currentTime = 0;
                this.testAudioElement = null;
            }
        }
        this.hideModel();
        this.isVideoLive = false
        this.utility.setItem('isVideCallLive', this.isVideoLive);
        this.isTestVideoCall = false;
        this.isTestScreenReady = false; // Reset ready flag
        this.isTestCallSessionStarting = false; // Reset session starting flag
        this.isInitializedFromNgOnInit = false; // Reset initialization flag for rejoin scenario
        
        // ✅ CRITICAL: Stop all streams immediately before showing dialog
        // Stop camera (Zoom SDK)
        if (this.localTestVideoTrack) {
            try {
                await this.localTestVideoTrack.stop();
            } catch (error: any) {
                // Handle VideoNotStartedError gracefully - track may already be stopped
                const isVideoNotStartedError = error?.name === 'Error' && 
                                              (error?.message === 'VideoNotStartedError' || 
                                               error?.message?.includes('VideoNotStartedError') ||
                                               error?.message?.includes('not started'));
                
                // VideoNotStartedError is expected when track is already stopped - silently handle
                if (!isVideoNotStartedError) {
                    console.error('Error stopping video track:', error);
                }
            }
            this.localTestVideoTrack = null;
            this.isTestCameraOn = false;
        }
        
        // Stop microphone (getUserMedia) - CRITICAL
        if (this.userMediaStream) {
            this.userMediaStream.getTracks().forEach(track => track.stop());
            this.userMediaStream = null;
            this.isTestMicOn = false;
            this.localAudioTrackInitlized = false;
        }
        
        // Stop speaker test (audio element)
        if (this.testAudioElement) {
            this.testAudioElement.pause();
            this.testAudioElement.currentTime = 0;
            this.testAudioElement.src = '';
            this.testAudioElement = null;
        }
        
        // Close audio context (for microphone analyser)
        if (this.audioContext) {
            await this.audioContext.close();
            this.audioContext = null;
        }
        
        const dialogRef = this.dialog.open(LeaveConfirmPopupComponent, {
            width: '600px',       // optional
            maxHeight: '90vh',    // optional
            disableClose: true,   // optional, prevents clicking outside to close
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.showVideModalPopUp = $('#showVideModalPopUp');
                this.showVideModalPopUp.modal('show');
                this.isInitializedFromNgOnInit = false; // Reset flag for rejoin scenario
                this.initializeTestCall();
                this.testCallStartSession();
            } else {
                this.completeTest();
            }
        });
    }
    async closeDialog() {
        this.isLeavePopUp = false;
        this.isTestVideoCall = true;
        
        // ✅ CRITICAL: Ensure cleanup happens before closing
        await this.completeTest();
        
        this.spinner.show();
        this.isVideoLive = false;
        this.mentoringEvents.setOpenVideoContainer(this.isVideoLive);
        this.hideModel();
        this.utility.setItem('isVideCallLive', this.isVideoLive);
        this.mentoringEvents.setCodeOfConduct(false)
        this.spinner.hide();
    }
    stay() {
        this.isLeavePopUp = false;
        this.isTestVideoCall = true;
    }

    async shareScreen() {
        if(this.isScreenSharing) {
            this.zoomSession.stopShareScreen();
            this.resetLaoutWhileScreenShare();
            return;
        }
        if(this.isParticipantScreenShareActive) {
            this.toastr.info(this.toasterMessageChannels.participantSharing)
            return;
        }
        if (this.participantConnectedInRoom) {
            if(!this.isScreenshareReceiverConsent){
                this.clearScreenShareRequesterName();
                this.screenShareRecipientName = this.extractScreenShareRecipientName();
                this.isBottomPopupOpen = true;
                this.isSender = true;
                this.getScreenshareReceiverConsent();
                this.toastr.info(this.toasterMessageChannels.approvalScreenSharing)
                return;
            }
            
            // ✅ Safari detection: Safari's Zoom SDK expects canvas, not video element
            const userAgent = navigator.userAgent.toLowerCase();
            const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
            // In Safari, isStartShareScreenWithVideoElement() returns false, so we use canvas
            // For other browsers, follow what the SDK indicates
            const shouldUseVideoElement = !isSafari && this.zoomSession.isStartShareScreenWithVideoElement();
            
            if (shouldUseVideoElement) {
                const videoElement = document.querySelector('#my-screen-share-content-video') as HTMLVideoElement;
                if (!videoElement) {
                    console.error('Screen share video element not found');
                    const error = new Error('Screen share video element not found');
                    this.logVideoCallError(error, 'shareScreen_videoElementNotFound', {
                        shouldUseVideoElement: shouldUseVideoElement,
                        isSafari: isSafari
                    });
                    this.toastr.error('Screen share element not found. Please refresh and try again.');
                    return;
                }
                
                $(videoElement).css({
                    "display": "block",
                    "width": "100%",
                    "height": "100%",
                    "object-fit": "contain",
                    "max-width": "100%",
                    "max-height": "100%"
                })
                this.zoomSession
                    .startShareScreen(videoElement)
                    .then(() => {
                        this.setLayoutWhileScrrenshare();
                        this.isScreenSharing = true;
                    })
                    .catch((error) => {
                        console.error('Screen share error:', error);
                        this.logVideoCallError(error, 'shareScreen_videoElement', {
                            errorType: error?.type,
                            shouldUseVideoElement: shouldUseVideoElement,
                            isSafari: isSafari,
                            participantConnectedInRoom: this.participantConnectedInRoom
                            
                        });
                        this.toastr.error(error.reason || 'Failed to start screen sharing');
                        this.resetLaoutWhileScreenShare();
                    })
                // ✅ Store event handler for proper cleanup
                const passivelyStopShareHandler = (payload) => {
                    this.resetLaoutWhileScreenShare();
                    this.isScreenSharing = false;
                };
                this.zoomVideo.on('passively-stop-share', passivelyStopShareHandler);
                this.zoomEventHandlers.set('passively-stop-share', passivelyStopShareHandler);
            } else {
                const canvasElement = document.querySelector('#my-screen-share-content-canvas') as HTMLCanvasElement;
                if (!canvasElement) {
                    console.error('Screen share canvas element not found');
                    const error = new Error('Screen share canvas element not found');
                    this.logVideoCallError(error, 'shareScreen_canvasElementNotFound', {
                        shouldUseVideoElement: shouldUseVideoElement,
                        isSafari: isSafari
                    });
                    this.toastr.error('Screen share element not found. Please refresh and try again.');
                    return;
                }
                
                // ✅ Ensure canvas has proper dimensions (720p) - especially important for Safari
                if (canvasElement.width === 0 || canvasElement.height === 0) {
                    canvasElement.width = 1280;
                    canvasElement.height = 720;
                }
                
                $(canvasElement).css({
                    "display": "block",
                    "width": "100%",
                    "height": "100%",
                    "object-fit": "contain",
                    "max-width": "100%",
                    "max-height": "100%"
                });
                
                // ✅ Verify we're passing a canvas element (not video) - especially for Safari
                if (!(canvasElement instanceof HTMLCanvasElement)) {
                    console.error('Element is not a canvas:', canvasElement);
                    const error = new Error('Element is not a canvas element');
                    this.logVideoCallError(error, 'shareScreen_invalidCanvas', {
                        elementType: canvasElement ? (canvasElement as any).constructor?.name : 'unknown',
                        isSafari: isSafari
                    });
                    this.toastr.error('Screen share setup error. Please refresh and try again.');
                    return;
                }
                
                this.zoomSession
                    .startShareScreen(canvasElement)
                    .then(() => {
                        this.setLayoutWhileScrrenshare();
                        this.isScreenSharing = true;
                        // screen share successfully started and rendered
                    })
                    .catch((error) => {
                        console.error('Screen share error:', error);
                        this.logVideoCallError(error, 'shareScreen_canvas', {
                            errorType: error?.type,
                            shouldUseVideoElement: shouldUseVideoElement,
                            isSafari: isSafari,
                            canvasWidth: canvasElement.width,
                            canvasHeight: canvasElement.height
                        });
                        this.toastr.error(error.reason || 'Failed to start screen sharing');
                        this.resetLaoutWhileScreenShare();
                    })
            }
        } else {
            this.toastr.info(this.toasterMessageChannels.waitingForParticipantToShare)
        }
    }
    getScreenshareReceiverConsent() {
        const chat = this.zoomVideo.getChatClient()
        chat.sendToAll('canActiveScreenShare')
    }
    sendScreenshareReceiverConsent() {
        const chat = this.zoomVideo.getChatClient()
        chat.sendToAll('activeScreenShare')
        this.isBottomPopupOpen = false;
        this.clearScreenShareRequesterName();
    }
    denyScreenshareReceiverConsent() {
        const chat = this.zoomVideo.getChatClient()
        chat.sendToAll('denyScreenShare')
        this.isBottomPopupOpen = false;
        this.clearScreenShareRequesterName();
        this.clearScreenShareRecipientName();
    }

    private extractScreenShareRequesterName(payload: any): string | null {
        const sender = payload?.sender;
        if (!sender) {
            return null;
        }
        return sender.displayName || sender.name || sender.userName || sender.email || null;
    }

    private clearScreenShareRequesterName(): void {
        this.screenShareRequesterName = null;
    }

    private extractScreenShareRecipientName(): string | null {
        if (this.nameOfparticipant && this.nameOfparticipant.trim()) {
            return this.nameOfparticipant;
        }
        const currentUserId = this.zoomVideo.getCurrentUserInfo()?.userId;
        const participant = this.listOfParticipantInRoom.find(p => p.userId !== currentUserId);
        return participant?.displayName || null;
    }

    private clearScreenShareRecipientName(): void {
        this.screenShareRecipientName = null;
    }

    /**
     * ✅ Helper method to check for and subscribe to active screen shares
     * This is called during initialization and when users are added (reconnection scenario)
     * to ensure reconnecting users can see active screen shares
     */
    private checkAndSubscribeToActiveScreenShares(zoomSession: any): void {
        if (!zoomSession || !this.zoomVideo) {
            return;
        }
        
        // Get current user info to avoid subscribing to our own screen share
        const currentUserInfo = this.zoomVideo.getCurrentUserInfo();
        const currentUserId = currentUserInfo?.userId;
        
        // Check all users for active screen shares
        this.zoomVideo.getAllUser().forEach((user) => {
            // Only subscribe to other users' screen shares, not our own
            if (user.sharerOn && user.userId !== currentUserId) {
                // Subscribe to the screen share (even if already active, this ensures reconnection works)
                this.isParticipantScreenShareActive = true;
                $('#users-screen-share-content-canvas').css({
                    'display': 'block',
                    'width': '100%',
                    'height': '100%',
                    'object-fit': 'contain',
                    'max-width': '100%',
                    'max-height': '100%'
                });
                // ✅ Use 720p for screen sharing to avoid quality downgrade warning
                try {
                    zoomSession.startShareView(
                        document.querySelector('#users-screen-share-content-canvas'),
                        user.userId, 1280, 720, 0, 0, 3
                    );
                    this.setLayoutWhileScrrenshare();
                } catch (error) {
                    console.error('Error subscribing to screen share on reconnect:', error);
                    this.logVideoCallError(error, 'checkAndSubscribeToActiveScreenShares', {
                        userId: user.userId,
                        currentUserId: currentUserId
                    });
                }
            }
        });
    }

    setLayoutWhileScrrenshare() {
        // Store the original position of the participant video before screen sharing
        const participantElement = document.getElementById('remote-videoTrack-container') as HTMLElement;
        if (participantElement) {
            this.originalParticipantTransform = participantElement.style.transform || '';
        }

        $('.conatainer-inner').css({
            "display": "flex",
            "justify-content": "center"
        })

        $('.left').css({
            "display": "unset",
            "width": "100%",
            "height": "inherit",
            "position": "relative",
            "left": '10px',
            "top":'10px',
            "max-height": '589px'
        })

        $('.right').css({
            "width": "25%"
        })

        $('.right-participants').css({
            "position": "absolute",
            "bottom": "4rem"
        })

        $('.local-videoTrack').css({
            'margin': '10px',
            'top': '4rem'
        })
        $('.container1').css({
            // 'left': '40%'
            })
        $('.remote-videoTrack').addClass('remote-when-screen-share')
    }

    resetLaoutWhileScreenShare() {
        this.isScreenSharing = false;
        
        // Reset participant video position to original location
        const participantElement = document.getElementById('remote-videoTrack-container') as HTMLElement;
        if (participantElement) {
            participantElement.style.transform = this.originalParticipantTransform || 'translate(0px, 0px)';
        }
        
        $('.conatainer-inner').css({
            "display": "unset",
            "justify-content": "unset"
        })

        $('.left').css({
            "display": "none",
            "width": "unset"
        })

        $('.right').css({
            "width": "100%"
        })

        $('.local-videoTrack').css({
            'margin': 'unset',
            'top': '17px'
        })

        $('.remote-videoTrack').removeClass('remote-when-screen-share') 
        
        $('#my-screen-share-content-video').css({
            "display": "none"
        })

        $('#my-screen-share-content-canvas').css({
            'display': 'none'
        })

        $('#users-screen-share-content-canvas').css({
            'display': 'none'
        })
        $('.container1').css({
            'left': ''
            })
    }
}
